import { Signer, providers, Wallet, BigNumber, utils, ContractFactory, Contract } from 'ethers';
import base64url from 'base64url';
import WalletConnectProvider from '@walletconnect/ethereum-provider';
import { Chain, Methods, isValidErc1056EWC, isValidErc1056VOLTA } from '@ew-did-registry/did';
import { VoltaAddress1056, addressOf, EwSigner, Operator } from '@ew-did-registry/did-ethr-resolver';
import { VOLTA_ENS_REGISTRY_ADDRESS, VOLTA_RESOLVER_V1_ADDRESS, VOLTA_PUBLIC_RESOLVER_ADDRESS, VOLTA_DOMAIN_NOTIFER_ADDRESS, VOLTA_IDENTITY_MANAGER_ADDRESS, VOLTA_CLAIM_MANAGER_ADDRESS, VOLTA_STAKING_POOL_FACTORY_ADDRESS, EWC_CHAIN_ID, VOLTA_CHAIN_ID as VOLTA_CHAIN_ID$1, DomainReader, ResolverContractType, DomainTransactionFactory, DomainHierarchy, PreconditionType } from '@energyweb/iam-contracts';
export { PreconditionType } from '@energyweb/iam-contracts';
import EKC from '@energyweb/ekc';
import { resolveProperties } from '@ethersproject/properties';
import { computeAddress } from 'ethers/lib/utils';
import detectMetamask from '@metamask/detect-provider';
import WalletConnect from '@walletconnect/client';
import QRCodeModal from '@walletconnect/qrcode-modal';
import { SafeAppProvider } from '@gnosis.pm/safe-apps-provider';
import { KeyType, privToPem } from '@ew-did-registry/keys';
import { JWT, Algorithms } from '@ew-did-registry/jwt';
import { ProxyOperator } from '@ew-did-registry/proxyidentity';
import { Encoding, KeyTags, ProviderTypes, DIDAttribute } from '@ew-did-registry/did-resolver-interface';
export { DIDAttribute, PubKeyType } from '@ew-did-registry/did-resolver-interface';
import { DIDDocumentFull } from '@ew-did-registry/did-document';
import { DidStore } from '@ew-did-registry/did-ipfs-store';
import { ProofVerifier, ClaimsUser, ClaimsIssuer, hashes } from '@ew-did-registry/claims';
import { JSONCodec, connect } from 'nats.ws/lib/src/mod.js';
import axios from 'axios';
import { stringify } from 'qs';
import { normalize } from 'eth-ens-namehash';
import jsonwebtoken from 'jsonwebtoken';
import { v4 } from 'uuid';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

var ERROR_MESSAGES;

(function (ERROR_MESSAGES) {
  ERROR_MESSAGES["UNKNOWN_PROVIDER"] = "Unknown provider type";
  ERROR_MESSAGES["ENS_TYPE_NOT_SUPPORTED"] = "ENS type not supported";
  ERROR_MESSAGES["WALLET_PROVIDER_NOT_SUPPORTED"] = "Wallet provider must be a supported value";
  ERROR_MESSAGES["NON_ETH_SIGN_SIGNATURE"] = "Signature is not eth_sign verifiable";
  ERROR_MESSAGES["ORG_WITH_APPS"] = "You are not able to remove organization with registered apps";
  ERROR_MESSAGES["ORG_WITH_ROLES"] = "You are not able to remove organization with registered roles";
  ERROR_MESSAGES["APP_WITH_ROLES"] = "You are not able to remove application with registered roles";
  ERROR_MESSAGES["METAMASK_PROVIDER_NOT_DETECTED"] = "Metamask provider not detected";
  ERROR_MESSAGES["METAMASK_ACCOUNT_NOT_PROVIDED"] = "Metamask account not provided";
  ERROR_MESSAGES["ROLE_PREREQUISITES_NOT_MET"] = "Enrolment subject doesn't have required roles";
  ERROR_MESSAGES["ROLE_NOT_EXISTS"] = "Role you want to enroll to does not exists";
  ERROR_MESSAGES["CAN_NOT_UPDATE_NOT_CONTROLLED_DOCUMENT"] = "Can not update not controlled document";
  ERROR_MESSAGES["ONCHAIN_ROLE_VERSION_NOT_SPECIFIED"] = "On-chain role version not specified";
  ERROR_MESSAGES["WITHDRAWAL_WAS_NOT_REQUESTED"] = "Stake withdrawal was not requested";
  ERROR_MESSAGES["STAKE_WAS_NOT_PUT"] = "Stake was not put";
  ERROR_MESSAGES["INSUFFICIENT_BALANCE"] = "Signer has insufficient balance";
  ERROR_MESSAGES["NOT_AUTHORIZED_TO_CHANGE_DOMAIN"] = "Not authorized to change domain";
  ERROR_MESSAGES["ERROR_IN_AZURE_PROVIDER"] = "Error in Azure Provider";
  ERROR_MESSAGES["JWT_ALGORITHM_NOT_SUPPORTED"] = "Jwt algorithm not supported";
  ERROR_MESSAGES["CLAIM_WAS_NOT_ISSUED"] = "Claim was not issued";
  ERROR_MESSAGES["PUBLISH_NOT_ISSUED_CLAIM"] = "Claim to publish has not been issued";
  ERROR_MESSAGES["CLAIM_TYPE_REQUIRED_FOR_ON_CHAIN_REGISTRATION"] = "claimType required for on-chain registration";
  ERROR_MESSAGES["TOKEN_REQUIRED_FOR_OFF_CHAIN_REGISTRATION"] = "token required for off-chain registration";
  ERROR_MESSAGES["ENS_OWNER_NOT_VALID_ADDRESS"] = "Provided owner is not a valid address. Owner of ENS domain must be an address";
  ERROR_MESSAGES["IS_ETH_SIGNER_NOT_SET"] = "Can not determine if signer is conformant with eth_sign specification";
})(ERROR_MESSAGES || (ERROR_MESSAGES = {}));

const emptyAddress = '0x0000000000000000000000000000000000000000';
const VOLTA_CHAIN_ID = 73799;
const defaultBridgeUrl = 'https://bridge.walletconnect.org';
const defaultKmsServerUrl = 'https://km.aws.energyweb.org/connect/new';
const defaultAzureProxyUrl = 'https://azure-proxy-server.energyweb.org/api/v1';

const EWC_CLAIM_MANAGER_ADDRESS = '0x23b026631A6f265d17CFee8aa6ced1B244f3920C';
const EWC_ENS_REGISTRY_ADDRESS = '0x0A6d64413c07E10E890220BBE1c49170080C6Ca0';
const EWC_RESOLVER_V1_ADDRESS = '0x70ad37DfeB1C05290F4bBd22188FA19Bc154A0ea';
const EWC_PUBLIC_RESOLVER_ADDRESS = '0xA517983Bd4Af4DF0Ed9b52DA4BC405d0A95eE7E2';
const EWC_DOMAIN_NOTIFER_ADDRESS = '0x5491Db3cC1f3AFf6C229e061735F92936004da3c';
const EWC_IDENTITY_MANAGER_ADDRESS = '0x2d1569f3a2006d21c0dc60eb13c8557b63ce5a8d';
const EwcAddress1056 = '0xE29672f34e92b56C9169f9D485fFc8b9A136BCE4';
const chainConfig = {
  [VOLTA_CHAIN_ID]: {
    chainName: Chain.VOLTA,
    chainDisplayName: 'Energy Web Volta Testnet',
    rpcUrl: 'https://volta-rpc.energyweb.org/',
    ensRegistryAddress: VOLTA_ENS_REGISTRY_ADDRESS,
    ensResolverAddress: VOLTA_RESOLVER_V1_ADDRESS,
    ensPublicResolverAddress: VOLTA_PUBLIC_RESOLVER_ADDRESS,
    domainNotifierAddress: VOLTA_DOMAIN_NOTIFER_ADDRESS,
    assetManagerAddress: VOLTA_IDENTITY_MANAGER_ADDRESS,
    didRegistryAddress: VoltaAddress1056,
    claimManagerAddress: VOLTA_CLAIM_MANAGER_ADDRESS,
    stakingPoolFactoryAddress: VOLTA_STAKING_POOL_FACTORY_ADDRESS
  },
  [EWC_CHAIN_ID]: {
    chainName: Chain.EWC,
    chainDisplayName: 'Energy Web Chain',
    rpcUrl: 'https://rpc.energyweb.org/',
    ensRegistryAddress: EWC_ENS_REGISTRY_ADDRESS,
    ensResolverAddress: EWC_RESOLVER_V1_ADDRESS,
    ensPublicResolverAddress: EWC_PUBLIC_RESOLVER_ADDRESS,
    domainNotifierAddress: EWC_DOMAIN_NOTIFER_ADDRESS,
    assetManagerAddress: EWC_IDENTITY_MANAGER_ADDRESS,
    didRegistryAddress: EwcAddress1056,
    claimManagerAddress: EWC_CLAIM_MANAGER_ADDRESS,
    stakingPoolFactoryAddress: ''
  }
};
const chainConfigs = () => Object.assign({}, chainConfig);
const setChainConfig = (chainId, config) => {
  chainConfig[chainId] = Object.assign(Object.assign({}, chainConfig[chainId]), config);
};

var ExecutionEnvironment;

(function (ExecutionEnvironment) {
  ExecutionEnvironment["NODE"] = "ExecutionEnvironment:Node";
  ExecutionEnvironment["BROWSER"] = "ExecutionEnvironment:Browser";
})(ExecutionEnvironment || (ExecutionEnvironment = {}));

const executionEnvironment = () => isNode() && !isBrowser() ? ExecutionEnvironment.NODE : ExecutionEnvironment.BROWSER;

const isNode = () => typeof process !== 'undefined' && process.versions != null && process.versions.node != null;

const isBrowser = () => typeof window !== 'undefined' && typeof window.document !== 'undefined';

var ProviderType;

(function (ProviderType) {
  ProviderType["WalletConnect"] = "WalletConnect";
  ProviderType["EwKeyManager"] = "EwKeyManager";
  ProviderType["MetaMask"] = "MetaMask";
  ProviderType["PrivateKey"] = "PrivateKey";
  ProviderType["Gnosis"] = "Gnosis";
  ProviderType["EKC"] = "Enterprise Key Connect";
})(ProviderType || (ProviderType = {}));

var ProviderEvent;

(function (ProviderEvent) {
  ProviderEvent["AccountChanged"] = "accountsChanged";
  ProviderEvent["NetworkChanged"] = "networkChanged";
  ProviderEvent["Disconnected"] = "disconnect";
  ProviderEvent["SessionUpdate"] = "session_update";
})(ProviderEvent || (ProviderEvent = {}));

const PUBLIC_KEY = 'PublicKey';
const IS_ETH_SIGNER = 'isEthSigner';

class ENSTypeNotSupportedError extends Error {
  constructor() {
    super(ERROR_MESSAGES.ENS_TYPE_NOT_SUPPORTED);
  }

}

class MethodNotAvailableInNodeEnvError extends Error {
  constructor(methodName) {
    super(`Method ${methodName} not supported in Node.js env`);
  }

}

class ChangeOwnershipNotPossibleError extends Error {
  constructor({
    namespace,
    notOwnedNamespaces
  }) {
    super(`Change ownership of ${namespace} not possible because you're not owner of ${notOwnedNamespaces.join(', ')} ${notOwnedNamespaces.length > 1 ? 'namespaces' : 'namespace'}`);
  }

}

class DeletingNamespaceNotPossibleError extends Error {
  constructor({
    namespace,
    notOwnedNamespaces
  }) {
    super(`Deleting ${namespace} not possible because you're not owner of ${notOwnedNamespaces.join(', ')} ${notOwnedNamespaces.length > 1 ? 'namespaces' : 'namespace'}`);
  }

}

class ENSOwnerNotValidAddressError extends Error {
  constructor(providedOwner) {
    super(`Provided owner param: ${providedOwner}. ${ERROR_MESSAGES.ENS_OWNER_NOT_VALID_ADDRESS}`);
  }

}

class MalformedDIDError extends Error {
  constructor(did) {
    super(`${did} is malformed`);
  }

}

class EkcSigner extends Signer {
  constructor(ekc) {
    super();
    this.ekc = ekc;
    this._signer = ekc.getSigner();
    this.provider = ekc._getProvider();
  }

  static create(proxyUrl) {
    return __awaiter(this, void 0, void 0, function* () {
      try {
        const ekc = yield EKC.init({
          proxyUrl
        });
        yield ekc.login({
          mode: 'popup'
        });
        return new EkcSigner(ekc);
      } catch (error) {
        throw new Error(ERROR_MESSAGES.ERROR_IN_AZURE_PROVIDER);
      }
    });
  }

  getAddress() {
    return this._signer.getAddress();
  }

  signMessage(message) {
    return this._signer.signMessage(message);
  }

  signTransaction(transaction) {
    return __awaiter(this, void 0, void 0, function* () {
      const resolvedTx = yield resolveProperties(transaction);
      return this._signer.signTransaction(resolvedTx);
    });
  }

  connect(provider) {
    return this._signer.connect(provider);
  }

}

const {
  arrayify: arrayify$1,
  keccak256: keccak256$1,
  recoverPublicKey,
  getAddress,
  hashMessage,
  verifyMessage
} = utils;
class SignerService {
  constructor(_signer, _providerType) {
    this._signer = _signer;
    this._providerType = _providerType;
    this._servicesInitializers = [];
    this._walletEventListeners = [];
  }

  init() {
    var e_1, _a;

    return __awaiter(this, void 0, void 0, function* () {
      if (executionEnvironment() === ExecutionEnvironment.BROWSER) {
        this._publicKey = localStorage.getItem(PUBLIC_KEY);
      }

      this._address = yield this.signer.getAddress();
      this._chainId = (yield this._signer.provider.getNetwork()).chainId;
      this._chainDisplayName = chainConfigs()[this._chainId].chainDisplayName;
      this._chainName = chainConfigs()[this._chainId].chainName;

      if (this._signer instanceof providers.JsonRpcSigner) {
        this._account = (yield this._signer.provider.listAccounts())[0];
      } else if (this._signer instanceof Wallet) {
        this._account = this._address;
      }

      if (executionEnvironment() === ExecutionEnvironment.BROWSER) {
        const isEthSigner = localStorage.getItem(IS_ETH_SIGNER);

        if (isEthSigner === 'true') {
          this._isEthSigner = true;
        } else if (isEthSigner === 'false') {
          this._isEthSigner = false;
        }
      }

      this.initEventHandlers();

      try {
        for (var _b = __asyncValues(this._servicesInitializers), _c; _c = yield _b.next(), !_c.done;) {
          const initializer = _c.value;
          yield initializer();
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) yield _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    });
  }

  onInit(initializer) {
    this._servicesInitializers.push(initializer);
  }

  emit(e) {
    return __awaiter(this, void 0, void 0, function* () {
      yield Promise.all(this._walletEventListeners.map(({
        event,
        cb
      }) => {
        return e === event ? cb() : null;
      }).filter(Boolean));
    });
  }

  on(event, cb) {
    this._walletEventListeners.push({
      event,
      cb
    });
  }

  initEventHandlers() {
    const accChangedHandler = () => __awaiter(this, void 0, void 0, function* () {
      yield this.closeConnection();
      yield this.init();
    });

    if (this._providerType === ProviderType.MetaMask) {
      this.on(ProviderEvent.AccountChanged, accChangedHandler);
      this.on(ProviderEvent.NetworkChanged, accChangedHandler);
    } else if (this._providerType === ProviderType.WalletConnect) {
      this.on(ProviderEvent.SessionUpdate, accChangedHandler);
      this.on(ProviderEvent.Disconnected, this.closeConnection);
    }
  }

  get signer() {
    return this._signer;
  }

  get isEthSigner() {
    return this._isEthSigner;
  }

  get address() {
    return this._address;
  }

  get accountInfo() {
    return {
      account: this._account,
      chainId: this._chainId,
      chainName: this._chainDisplayName
    };
  }

  get provider() {
    return this._signer.provider;
  }

  get chainId() {
    return this._chainId;
  }

  balance() {
    return __awaiter(this, void 0, void 0, function* () {
      return this.signer.getBalance();
    });
  }

  get providerType() {
    return this._providerType;
  }

  get did() {
    return `did:${Methods.Erc1056}:${this.chainName()}:${this._address}`;
  }

  send({
    to,
    data,
    value
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      const tx = Object.assign({
        to,
        from: this.address,
        data
      }, value && {
        value: BigNumber.from(value)
      });
      const receipt = yield (yield this._signer.sendTransaction(tx)).wait();
      return receipt;
    });
  }

  call({
    to,
    data
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      const tx = {
        to,
        from: this.address,
        data
      };
      const result = yield this._signer.call(tx);
      return result;
    });
  }

  signMessage(message) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._isEthSigner === undefined) {
        throw new Error(ERROR_MESSAGES.IS_ETH_SIGNER_NOT_SET);
      }

      const messageHash = this._isEthSigner ? message : arrayify$1(hashMessage(message));
      const sig = yield this.signer.signMessage(messageHash);

      if (getAddress(this._address) !== getAddress(verifyMessage(message, sig))) {
        throw new Error(ERROR_MESSAGES.NON_ETH_SIGN_SIGNATURE);
      }

      return sig;
    });
  }

  connect(signer, providerType) {
    return __awaiter(this, void 0, void 0, function* () {
      this._signer = signer;
      this._providerType = providerType;
      yield this.init();
    });
  }

  closeConnection() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._signer instanceof WalletConnectProvider) {
        yield this._signer.disconnect();
      } else if (this._signer instanceof EkcSigner) {
        try {
          yield this._signer.ekc.logout({
            mode: 'popup'
          });
          return false;
        } catch (error) {
          console.log('error in azure logout ', error);
        }
      }

      return true;
    });
  }

  publicKey() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._publicKey) return this._publicKey;else if (this._signer instanceof Wallet) {
        this._publicKey = this._signer.publicKey;
      } else {
        this._publicKey = (yield this.publicKeyAndIdentityToken()).publicKey;
      }
      return this._publicKey;
    });
  }

  chainName() {
    return this._chainName;
  }

  publicKeyAndIdentityToken() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this._publicKey || !this._identityToken) {
        yield this._calculatePubKeyAndIdentityToken();
      }

      return {
        publicKey: this._publicKey,
        identityToken: this._identityToken
      };
    });
  }

  _calculatePubKeyAndIdentityToken() {
    return __awaiter(this, void 0, void 0, function* () {
      const header = {
        alg: 'ES256',
        typ: 'JWT'
      };
      const encodedHeader = base64url(JSON.stringify(header));
      const address = this._address;
      const payload = {
        iss: `did:${Methods.Erc1056}:${this.chainName()}:${address}`,
        claimData: {
          blockNumber: yield this._signer.provider.getBlockNumber()
        }
      };
      const encodedPayload = base64url(JSON.stringify(payload));
      const token = `0x${Buffer.from(`${encodedHeader}.${encodedPayload}`).toString('hex')}`;
      const message = arrayify$1(keccak256$1(token));
      const digest = arrayify$1(hashMessage(message));
      const sig = yield this._signer.signMessage(message);
      const keyFromMessage = recoverPublicKey(message, sig);
      const keyFromDigest = recoverPublicKey(digest, sig);

      if (getAddress(this._address) === computeAddress(keyFromMessage)) {
        this._publicKey = keyFromMessage;
        this._isEthSigner = false;
      } else if (getAddress(this._address) === computeAddress(keyFromDigest)) {
        this._publicKey = keyFromDigest;
        this._isEthSigner = true;
      } else {
        throw new Error(ERROR_MESSAGES.NON_ETH_SIGN_SIGNATURE);
      }

      this._identityToken = `${encodedHeader}.${encodedPayload}.${base64url(sig)}`;
    });
  }

}

const {
  JsonRpcProvider: JsonRpcProvider$1
} = providers;
const fromPrivateKey = (privateKey, rpcUrl) => __awaiter(void 0, void 0, void 0, function* () {
  const provider = new JsonRpcProvider$1({
    url: rpcUrl
  });
  const signerService = new SignerService(new Wallet(privateKey).connect(provider), ProviderType.PrivateKey);
  yield signerService.init();
  return signerService;
});

const fromMetaMask = () => __awaiter(void 0, void 0, void 0, function* () {
  const provider = yield createMetamaskProvider();
  const signer = new providers.Web3Provider(provider).getSigner();
  console.log('metamask chain id:', (yield signer.provider.getNetwork()).chainId);
  const signerService = new SignerService(signer, ProviderType.MetaMask);
  provider.on(ProviderEvent.AccountChanged, () => signerService.emit(ProviderEvent.AccountChanged));
  provider.on(ProviderEvent.NetworkChanged, () => signerService.emit(ProviderEvent.NetworkChanged));
  yield signerService.init();
  return signerService;
});

const createMetamaskProvider = () => __awaiter(void 0, void 0, void 0, function* () {
  const metamaskProvider = yield detectMetamask({
    mustBeMetaMask: true
  });

  if (!metamaskProvider) {
    throw new Error(ERROR_MESSAGES.METAMASK_PROVIDER_NOT_DETECTED);
  }

  const requestObject = {
    method: 'eth_accounts',
    params: [{
      eth_accounts: {}
    }]
  };
  const accounts = yield metamaskProvider.request(requestObject);

  if (accounts.length < 1) {
    yield metamaskProvider.request({
      method: 'wallet_requestPermissions',
      params: [{
        eth_accounts: {}
      }]
    });
  }

  return metamaskProvider;
});

const isMetamaskExtensionPresent = () => __awaiter(void 0, void 0, void 0, function* () {
  const provider = yield detectMetamask({
    mustBeMetaMask: true
  });
  const chainId = provider && 'request' in provider && provider.request instanceof Function ? yield provider === null || provider === void 0 ? void 0 : provider.request({
    method: 'eth_chainId'
  }) : undefined;
  return {
    isMetamaskPresent: !!provider,
    chainId
  };
});

const fromWalletConnectMetamask = (bridge, infuraId) => __awaiter(void 0, void 0, void 0, function* () {
  const walletProvider = createWalletConnectProvider(bridge, infuraId);
  yield walletProvider.enable();
  const provider = new providers.Web3Provider(walletProvider);
  const signerService = new SignerService(provider.getSigner(), ProviderType.WalletConnect);
  walletProvider.on(ProviderEvent.Disconnected, () => signerService.emit(ProviderEvent.Disconnected));
  walletProvider.on(ProviderEvent.SessionUpdate, () => signerService.emit(ProviderEvent.SessionUpdate));
  yield signerService.init();
  return signerService;
});
const createWalletConnectProvider = (bridge, infuraId) => {
  const rpc = Object.entries(chainConfigs()).reduce((urls, [id, config]) => Object.assign(Object.assign({}, urls), {
    [id]: config.rpcUrl
  }), {});
  const walletConnectProvider = new WalletConnectProvider({
    rpc,
    connector: new Connector({
      bridge,
      qrcodeModal: QRCodeModal
    }),
    infuraId
  });
  return walletConnectProvider;
};

class Connector extends WalletConnect {
  createSession(opts) {
    const _super = Object.create(null, {
      createSession: {
        get: () => super.createSession
      }
    });

    return __awaiter(this, void 0, void 0, function* () {
      yield _super.createSession.call(this, opts);
    });
  }

}

function fromKms(bridge, kmsServerUrl, infuraId) {
  return __awaiter(this, void 0, void 0, function* () {
    const walletConnectProvider = createWalletConnectProvider(bridge, infuraId);
    walletConnectProvider.on('display_uri', (_, payload) => {
      const wcUri = payload.params[0];
      const encoded = encodeURIComponent(wcUri);
      const hasQueryString = kmsServerUrl.includes('?');
      const url = `${kmsServerUrl}${hasQueryString ? '&' : '?'}uri=${encoded}`;
      window.open(url, 'ew_key_manager');
    });
    yield walletConnectProvider.enable();
    const provider = new providers.Web3Provider(walletConnectProvider);
    const signerService = new SignerService(provider.getSigner(), ProviderType.WalletConnect);
    yield signerService.init();
    return signerService;
  });
}

const fromGnosis = safeAppSdk => __awaiter(void 0, void 0, void 0, function* () {
  const gnosisProvider = new SafeAppProvider(yield safeAppSdk.safe.getInfo(), safeAppSdk);
  const provider = new providers.Web3Provider(gnosisProvider);
  const signerService = new SignerService(provider.getSigner(), ProviderType.Gnosis);
  return signerService;
});

const _abi$6 = [{
  inputs: [{
    internalType: "uint256",
    name: "_principalThreshold",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "_withdrawDelay",
    type: "uint256"
  }, {
    internalType: "address",
    name: "_claimManager",
    type: "address"
  }, {
    internalType: "address",
    name: "_ensRegistry",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "org",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "pool",
    type: "address"
  }],
  name: "StakingPoolLaunched",
  type: "event"
}, {
  inputs: [],
  name: "rewardPool",
  outputs: [{
    internalType: "address payable",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  name: "services",
  outputs: [{
    internalType: "address",
    name: "provider",
    type: "address"
  }, {
    internalType: "address",
    name: "pool",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "org",
    type: "bytes32"
  }, {
    internalType: "uint256",
    name: "minStakingPeriod",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "patronRewardPortion",
    type: "uint256"
  }, {
    internalType: "bytes32[]",
    name: "patronRoles",
    type: "bytes32[]"
  }],
  name: "launchStakingPool",
  outputs: [],
  stateMutability: "payable",
  type: "function"
}, {
  inputs: [],
  name: "orgsList",
  outputs: [{
    internalType: "bytes32[]",
    name: "",
    type: "bytes32[]"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "pool",
    type: "address"
  }],
  name: "isPool",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}];
const _bytecode$6 = "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";
class StakingPoolFactory__factory extends ContractFactory {
  constructor(...args) {
    if (args.length === 1) {
      super(_abi$6, _bytecode$6, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(_principalThreshold, _withdrawDelay, _claimManager, _ensRegistry, overrides) {
    return super.deploy(_principalThreshold, _withdrawDelay, _claimManager, _ensRegistry, overrides || {});
  }

  getDeployTransaction(_principalThreshold, _withdrawDelay, _claimManager, _ensRegistry, overrides) {
    return super.getDeployTransaction(_principalThreshold, _withdrawDelay, _claimManager, _ensRegistry, overrides || {});
  }

  attach(address) {
    return super.attach(address);
  }

  connect(signer) {
    return super.connect(signer);
  }

  static createInterface() {
    return new utils.Interface(_abi$6);
  }

  static connect(address, signerOrProvider) {
    return new Contract(address, _abi$6, signerOrProvider);
  }

}
StakingPoolFactory__factory.bytecode = _bytecode$6;
StakingPoolFactory__factory.abi = _abi$6;

const _abi$5 = [{
  inputs: [{
    internalType: "uint256",
    name: "_minStakingPeriod",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "_withdrawDelay",
    type: "uint256"
  }, {
    internalType: "address",
    name: "_claimManager",
    type: "address"
  }, {
    internalType: "bytes32[]",
    name: "_patronRoles",
    type: "bytes32[]"
  }, {
    internalType: "address payable",
    name: "_rewardPool",
    type: "address"
  }, {
    internalType: "uint256",
    name: "_patronRewardPortion",
    type: "uint256"
  }],
  stateMutability: "payable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "patron",
    type: "address"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "amount",
    type: "uint256"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "timestamp",
    type: "uint256"
  }],
  name: "StakePut",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "patron",
    type: "address"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "timestamp",
    type: "uint256"
  }],
  name: "StakeWithdrawalRequested",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "patron",
    type: "address"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "timestamp",
    type: "uint256"
  }],
  name: "StakeWithdrawn",
  type: "event"
}, {
  inputs: [],
  name: "minStakingPeriod",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  name: "stakes",
  outputs: [{
    internalType: "uint256",
    name: "amount",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "depositStart",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "depositEnd",
    type: "uint256"
  }, {
    internalType: "enum StakingPool.StakeStatus",
    name: "status",
    type: "uint8"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "totalStake",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "withdrawDelay",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "putStake",
  outputs: [],
  stateMutability: "payable",
  type: "function"
}, {
  inputs: [],
  name: "requestWithdraw",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "withdraw",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "checkReward",
  outputs: [{
    internalType: "uint256",
    name: "reward",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}];
const _bytecode$5 = "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";
class StakingPool__factory$1 extends ContractFactory {
  constructor(...args) {
    if (args.length === 1) {
      super(_abi$5, _bytecode$5, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(_minStakingPeriod, _withdrawDelay, _claimManager, _patronRoles, _rewardPool, _patronRewardPortion, overrides) {
    return super.deploy(_minStakingPeriod, _withdrawDelay, _claimManager, _patronRoles, _rewardPool, _patronRewardPortion, overrides || {});
  }

  getDeployTransaction(_minStakingPeriod, _withdrawDelay, _claimManager, _patronRoles, _rewardPool, _patronRewardPortion, overrides) {
    return super.getDeployTransaction(_minStakingPeriod, _withdrawDelay, _claimManager, _patronRoles, _rewardPool, _patronRewardPortion, overrides || {});
  }

  attach(address) {
    return super.attach(address);
  }

  connect(signer) {
    return super.connect(signer);
  }

  static createInterface() {
    return new utils.Interface(_abi$5);
  }

  static connect(address, signerOrProvider) {
    return new Contract(address, _abi$5, signerOrProvider);
  }

}
StakingPool__factory$1.bytecode = _bytecode$5;
StakingPool__factory$1.abi = _abi$5;

const {
  namehash: namehash$3,
  parseUnits: parseUnits$1
} = utils;
var StakeStatus;

(function (StakeStatus) {
  StakeStatus[StakeStatus["NONSTAKING"] = 0] = "NONSTAKING";
  StakeStatus[StakeStatus["STAKING"] = 1] = "STAKING";
  StakeStatus[StakeStatus["WITHDRAWING"] = 2] = "WITHDRAWING";
})(StakeStatus || (StakeStatus = {}));

class StakingService {
  constructor(_signerService, _domainsService) {
    this._signerService = _signerService;
    this._domainsService = _domainsService;

    this._signerService.onInit(this.init.bind(this));
  }

  static create(signerService, domainsService) {
    return __awaiter(this, void 0, void 0, function* () {
      const service = new StakingService(signerService, domainsService);
      yield service.init();
      return service;
    });
  }

  init() {
    return __awaiter(this, void 0, void 0, function* () {
      const chainId = this._signerService.chainId;
      this._stakingPoolFactoryAddress = chainConfigs()[chainId].stakingPoolFactoryAddress;
      this._stakingPoolFactory = new StakingPoolFactory__factory(StakingPoolFactory__factory.createInterface(), StakingPoolFactory__factory.bytecode).attach(this._stakingPoolFactoryAddress).connect(this._signerService.provider);
    });
  }

  launchPool({
    org,
    minStakingPeriod,
    patronRewardPortion,
    patronRoles,
    principal
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      const tx = {
        to: this._stakingPoolFactoryAddress,
        data: this._stakingPoolFactory.interface.encodeFunctionData('launchStakingPool', [namehash$3(org), minStakingPeriod, patronRewardPortion, patronRoles.map(r => namehash$3(r))]),
        value: principal
      };
      yield this._signerService.send(tx);
    });
  }

  allServices() {
    return __awaiter(this, void 0, void 0, function* () {
      const orgs = yield this._stakingPoolFactory.orgsList();
      return Promise.all(orgs.map(org => this._stakingPoolFactory.services(org).then(service => Object.assign(Object.assign({}, service), {
        org
      })).then(service => this._domainsService.readName(service.org).then(org => Object.assign(Object.assign({}, service), {
        org
      })))));
    });
  }

  getPool(org) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        pool
      } = yield this._stakingPoolFactory.connect(this._signerService.signer).services(namehash$3(org));

      if (pool === emptyAddress) {
        return null;
      }

      return new StakingPool(this._signerService, pool);
    });
  }

}
class StakingPool {
  constructor(signerService, address) {
    this.signerService = signerService;
    this.overrides = {
      gasPrice: parseUnits$1('0.01', 'gwei'),
      gasLimit: BigNumber.from(490000)
    };
    this.pool = new StakingPool__factory$1(StakingPool__factory$1.createInterface(), StakingPool__factory$1.bytecode).attach(address);
  }

  putStake(stake) {
    return __awaiter(this, void 0, void 0, function* () {
      stake = BigNumber.from(stake);
      const tx = {
        to: this.pool.address,
        from: this.signerService.address,
        data: this.pool.interface.encodeFunctionData('putStake'),
        value: stake
      };
      const [gasPrice, gas, balance] = yield Promise.all([this.signerService.signer.getGasPrice(), this.signerService.provider.estimateGas(tx), this.signerService.balance()]);
      const fee = gasPrice.mul(gas).mul(2);
      const maxStake = balance.sub(fee);

      if (maxStake.lte(0)) {
        throw new Error(ERROR_MESSAGES.INSUFFICIENT_BALANCE);
      }

      tx.value = stake.lt(maxStake) ? stake : maxStake;
      yield this.signerService.send(tx);
    });
  }

  requestWithdrawDelay() {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        depositStart,
        status
      } = yield this.getStake();

      if (status !== StakeStatus.STAKING) {
        throw new Error(ERROR_MESSAGES.STAKE_WAS_NOT_PUT);
      }

      const requestAvailableFrom = depositStart.add(yield this.pool.connect(this.signerService.signer).minStakingPeriod());
      const now = yield this.now();

      if (requestAvailableFrom.lte(now)) {
        return 0;
      } else {
        return requestAvailableFrom.sub(now).toNumber();
      }
    });
  }

  checkReward() {
    return __awaiter(this, void 0, void 0, function* () {
      return this.pool.connect(this.signerService.signer).checkReward();
    });
  }

  getStake(patron) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!patron) {
        patron = this.signerService.address;
      }

      return this.pool.connect(this.signerService.signer).stakes(patron);
    });
  }

  requestWithdraw() {
    return __awaiter(this, void 0, void 0, function* () {
      const tx = Object.assign({
        to: this.pool.address,
        data: this.pool.interface.encodeFunctionData('requestWithdraw')
      }, this.overrides);
      yield this.signerService.send(tx);
    });
  }

  withdrawalDelay() {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        depositEnd,
        status
      } = yield this.getStake();

      if (status !== StakeStatus.WITHDRAWING) {
        throw new Error(ERROR_MESSAGES.WITHDRAWAL_WAS_NOT_REQUESTED);
      }

      const withdrawAvailableFrom = depositEnd.add(yield this.pool.connect(this.signerService.signer).withdrawDelay());
      const now = yield this.now();

      if (withdrawAvailableFrom.lte(now)) {
        return 0;
      } else {
        return withdrawAvailableFrom.sub(now).toNumber();
      }
    });
  }

  withdraw() {
    return __awaiter(this, void 0, void 0, function* () {
      const tx = Object.assign({
        to: this.pool.address,
        data: this.pool.interface.encodeFunctionData('withdraw')
      }, this.overrides);
      yield this.signerService.send(tx);
    });
  }

  now() {
    return __awaiter(this, void 0, void 0, function* () {
      const lastBlock = yield this.signerService.provider.getBlockNumber();
      return BigNumber.from((yield this.signerService.provider.getBlock(lastBlock)).timestamp);
    });
  }

}

const _abi$4 = [{
  inputs: [{
    internalType: "bytes32",
    name: "_ownerRole",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "_claimManager",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "amount",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "time",
    type: "uint256"
  }],
  name: "StakeAdded",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "amount",
    type: "uint256"
  }],
  name: "StakeWithdrawn",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "uint256",
    name: "funded",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "timestamp",
    type: "uint256"
  }],
  name: "StakingPoolInitialized",
  type: "event"
}, {
  inputs: [],
  name: "claimManager",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "ratio",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "principal",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "compoundStart",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "compoundEnd",
    type: "uint256"
  }],
  name: "compound",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "contributionLimit",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "end",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "hardCap",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "hourlyRatio",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "_start",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "_end",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "_hourlyRatio",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "_hardCap",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "_contributionLimit",
    type: "uint256"
  }, {
    internalType: "bytes32[]",
    name: "_patronRoles",
    type: "bytes32[]"
  }],
  name: "init",
  outputs: [],
  stateMutability: "payable",
  type: "function"
}, {
  inputs: [],
  name: "stake",
  outputs: [],
  stateMutability: "payable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  name: "stakes",
  outputs: [{
    internalType: "uint256",
    name: "deposit",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "compounded",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "time",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "futureReward",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "start",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "sweep",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "sweeped",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "terminate",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "total",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "totalStaked",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "value",
    type: "uint256"
  }],
  name: "unstake",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "unstakeAll",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];
const _bytecode$4 = "0x60806040523480156200001157600080fd5b5060405162002eb938038062002eb98339818101604052810190620000379190620000b4565b81600881905550806000806101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff160217905550505062000172565b60008151905062000097816200013e565b92915050565b600081519050620000ae8162000158565b92915050565b60008060408385031215620000ce57620000cd62000139565b5b6000620000de858286016200009d565b9250506020620000f18582860162000086565b9150509250929050565b6000620001088262000119565b9050919050565b6000819050919050565b600073ffffffffffffffffffffffffffffffffffffffff82169050919050565b600080fd5b6200014981620000fb565b81146200015557600080fd5b50565b62000163816200010f565b81146200016f57600080fd5b50565b612d3780620001826000396000f3fe6080604052600436106100fe5760003560e01c806368eb7a6911610095578063a9a36dcd11610064578063a9a36dcd146102c1578063be9a6555146102ec578063eb01393314610317578063efbe1c1c14610342578063fb86a4041461036d576100fe565b806368eb7a69146102035780637332e0771461022e578063817b1cd21461025957806384c18c8914610284576100fe565b80633455b92d116100d15780633455b92d146101af57806335322f37146101cb57806335faa416146101e25780633a4b66f1146101f9576100fe565b80630c08bf881461010357806316934fc41461011a5780632ddbd13a1461015a5780632e17de7814610186575b600080fd5b34801561010f57600080fd5b50610118610398565b005b34801561012657600080fd5b50610141600480360381019061013c9190611efe565b610579565b6040516101519493929190612604565b60405180910390f35b34801561016657600080fd5b5061016f6105a9565b60405161017d9291906125db565b60405180910390f35b34801561019257600080fd5b506101ad60048036038101906101a89190611f58565b61067f565b005b6101c960048036038101906101c49190611fec565b61094e565b005b3480156101d757600080fd5b506101e0610c18565b005b3480156101ee57600080fd5b506101f7610c77565b005b610201610e79565b005b34801561020f57600080fd5b506102186111ec565b60405161022591906125c0565b60405180910390f35b34801561023a57600080fd5b506102436111f2565b60405161025091906125c0565b60405180910390f35b34801561026557600080fd5b5061026e6111f8565b60405161027b91906125c0565b60405180910390f35b34801561029057600080fd5b506102ab60048036038101906102a69190611f85565b6111fe565b6040516102b891906125c0565b60405180910390f35b3480156102cd57600080fd5b506102d661125d565b6040516102e39190612333565b60405180910390f35b3480156102f857600080fd5b50610301611281565b60405161030e91906125c0565b60405180910390f35b34801561032357600080fd5b5061032c611287565b6040516103399190612385565b60405180910390f35b34801561034e57600080fd5b5061035761129a565b60405161036491906125c0565b60405180910390f35b34801561037957600080fd5b506103826112a0565b60405161038f91906125c0565b60405180910390f35b600060015414156103de576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016103d590612480565b60405180910390fd5b61042b60008054906101000a900473ffffffffffffffffffffffffffffffffffffffff166008543373ffffffffffffffffffffffffffffffffffffffff166112a69092919063ffffffff16565b61046a576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161046190612520565b60405180910390fd5b4260015410156104af576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016104a6906123e0565b60405180910390fd5b600060095490506000600b60019054906101000a900473ffffffffffffffffffffffffffffffffffffffff169050600160009055600260009055600360009055600460009055600560009055600760006105099190611d81565b600b60016101000a81549073ffffffffffffffffffffffffffffffffffffffff02191690558073ffffffffffffffffffffffffffffffffffffffff166108fc839081150290604051600060405180830381858888f19350505050158015610574573d6000803e3d6000fd5b505050565b600c6020528060005260406000206000915090508060000154908060010154908060020154908060030154905084565b6000806000600c60003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020604051806080016040529081600082015481526020016001820154815260200160028201548152602001600382015481525050905060008160400151141561063c57600080925092505061067b565b6000600254421161064d5742610651565b6002545b9050600061066b60035484602001518560400151856111fe565b9050826000015181945094505050505b9091565b600060015414156106c5576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016106bc90612480565b60405180910390fd5b6000806106d06105a9565b9150915060008111610717576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161070e90612440565b60405180910390fd5b8281101561075a576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161075190612500565b60405180910390fd5b60008284111561076a578261076c565b835b9050600083851161077e57600061078b565b838561078a9190612732565b5b9050828514156107fc57600c60003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206000808201600090556001820160009055600282016000905560038201600090555050610867565b61085e82600c60003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206000015461084d9190612732565b86856108599190612732565b611344565b610866611474565b5b80600a60008282546108799190612732565b9250508190555080600960008282546108929190612732565b9250508190555081600660008282546108ab9190612732565b925050819055503373ffffffffffffffffffffffffffffffffffffffff166108fc869081150290604051600060405180830381858888f193505050501580156108f8573d6000803e3d6000fd5b503373ffffffffffffffffffffffffffffffffffffffff167f8108595eb6bad3acefa9da467d90cc2217686d5c5ac85460f8b7849c840645fc8660405161093f91906125c0565b60405180910390a25050505050565b61099b60008054906101000a900473ffffffffffffffffffffffffffffffffffffffff166008543373ffffffffffffffffffffffffffffffffffffffff166112a69092919063ffffffff16565b6109da576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016109d190612520565b60405180910390fd5b600060015414610a1f576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610a1690612400565b60405180910390fd5b42861015610a62576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610a5990612560565b60405180910390fd5b620151808686610a729190612732565b1015610ab3576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610aaa90612460565b60405180910390fd5b81831015610af6576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610aed906123c0565b60405180910390fd5b600083610b0586868a8a6111fe565b610b0f9190612732565b905080341015610b54576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610b4b906124c0565b60405180910390fd5b86600181905550856002819055508460038190555083600481905550826005819055508160079080519060200190610b8d929190611da2565b503460098190555033600b60016101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff1602179055507f3d828625fed4f186627245530300f39c5b54220393511f345c505ee3ddf6fc603442604051610c079291906125db565b60405180910390a150505050505050565b60006001541415610c5e576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610c5590612480565b60405180910390fd5b6000610c686105a9565b915050610c748161067f565b50565b60006001541415610cbd576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610cb490612480565b60405180910390fd5b610d0a60008054906101000a900473ffffffffffffffffffffffffffffffffffffffff166008543373ffffffffffffffffffffffffffffffffffffffff166112a69092919063ffffffff16565b610d49576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610d4090612520565b60405180910390fd5b600b60009054906101000a900460ff1615610d99576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610d9090612580565b60405180910390fd5b600254421015610dde576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610dd5906124e0565b60405180910390fd5b6000600a54600954610df09190612732565b90506001600b60006101000a81548160ff021916908315150217905550600b60019054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff166108fc829081150290604051600060405180830381858888f19350505050158015610e75573d6000803e3d6000fd5b5050565b33610f1560008054906101000a900473ffffffffffffffffffffffffffffffffffffffff166007805480602002602001604051908101604052809291908181526020018280548015610eea57602002820191906000526020600020905b815481526020019060010190808311610ed6575b50505050508373ffffffffffffffffffffffffffffffffffffffff1661153e9092919063ffffffff16565b610f54576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610f4b906123a0565b60405180910390fd5b60006001541415610f9a576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610f9190612480565b60405180910390fd5b60055434600c60003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060000154610feb91906126ab565b111561102c576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401611023906124a0565b60405180910390fd5b600154421015611071576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401611068906125a0565b60405180910390fd5b6002544211156110b6576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016110ad90612420565b60405180910390fd5b346006546004546110c79190612732565b1015611108576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016110ff90612540565b60405180910390fd5b60006111126105a9565b91505061117734600c60003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206000015461116691906126ab565b348361117291906126ab565b611344565b61117f611474565b346006600082825461119191906126ab565b925050819055503373ffffffffffffffffffffffffffffffffffffffff167f270d6dd254edd1d985c81cf7861b8f28fb06b6d719df04d90464034d4341244034426040516111e09291906125db565b60405180910390a25050565b60035481565b60055481565b60065481565b600080610e1084846112109190612732565b61121a9190612701565b905061125261124c61124661122f600161163c565b6112418a670de0b6b3a764000061165f565b6116c7565b8361172e565b86611a43565b915050949350505050565b60008054906101000a900473ffffffffffffffffffffffffffffffffffffffff1681565b60015481565b600b60009054906101000a900460ff1681565b60025481565b60045481565b6000808390508073ffffffffffffffffffffffffffffffffffffffff166395df7b1e868560016040518463ffffffff1660e01b81526004016112ea9392919061234e565b60206040518083038186803b15801561130257600080fd5b505afa158015611316573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061133a9190611f2b565b9150509392505050565b81600c60003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206000018190555080600c60003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060010181905550610e10600c60003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060020154426114239190612732565b106114705742600c60003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600201819055505b5050565b600061147e611afe565b9050600c60003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060030154600a60008282546114d49190612732565b9250508190555080600a60008282546114ed91906126ab565b9250508190555080600c60003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206003018190555050565b600080825114156115525760019050611635565b600083905060005b835181101561162e578173ffffffffffffffffffffffffffffffffffffffff166395df7b1e87868481518110611593576115926128d1565b5b602002602001015160016040518463ffffffff1660e01b81526004016115bb9392919061234e565b60206040518083038186803b1580156115d357600080fd5b505afa1580156115e7573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061160b9190611f2b565b1561161b57600192505050611635565b8080611626906127fb565b91505061155a565b5060009150505b9392505050565b6000677fffffffffffffff82111561165357600080fd5b604082901b9050919050565b60008082141561166e57600080fd5b600061167a8484611ba4565b90506f7fffffffffffffffffffffffffffffff6fffffffffffffffffffffffffffffffff16816fffffffffffffffffffffffffffffffff1611156116bd57600080fd5b8091505092915050565b60008082600f0b84600f0b0190507fffffffffffffffffffffffffffffffff80000000000000000000000000000000600f0b811215801561171b57506f7fffffffffffffffffffffffffffffff600f0b8113155b61172457600080fd5b8091505092915050565b600080600084600f0b12801561174657506001808416145b905060008085600f0b1261175a578461175f565b846000035b6fffffffffffffffffffffffffffffffff1690506000700100000000000000000000000000000000905068010000000000000000821161183957603f82901b91505b6000851461182d57600060018616146117be57607f828202901c90505b607f828302901c9150600060028616146117dc57607f828202901c90505b607f828302901c9150600060048616146117fa57607f828202901c90505b607f828302901c91506000600886161461181857607f828202901c90505b607f828302901c9150600485901c94506117a1565b604081901c90506119d3565b6000603f90506c0100000000000000000000000083101561186257602083901b92506020810390505b6e01000000000000000000000000000083101561188757601083901b92506010810390505b6f010000000000000000000000000000008310156118ad57600883901b92506008810390505b6f100000000000000000000000000000008310156118d357600483901b92506004810390505b6f400000000000000000000000000000008310156118f957600283901b92506002810390505b6f8000000000000000000000000000000083101561191f57600183901b92506001810390505b60005b600087146119ba576040821061193757600080fd5b6000600188161461197857607f848402901c9250818101905070010000000000000000000000000000000083111561197757600183901c92506001810190505b5b607f848502901c9350600182901b915070010000000000000000000000000000000084106119ae57600184901c93506001820191505b600187901c9650611922565b604081106119c757600080fd5b8060400383901c925050505b6000836119e057816119e5565b816000035b90507fffffffffffffffffffffffffffffffff80000000000000000000000000000000600f0b8112158015611a2d57506f7fffffffffffffffffffffffffffffff600f0b8113155b611a3657600080fd5b8094505050505092915050565b600080821415611a565760009050611af8565b600083600f0b1215611a6757600080fd5b600060406fffffffffffffffffffffffffffffffff841685600f0b02901c90506000608084901c85600f0b02905077ffffffffffffffffffffffffffffffffffffffffffffffff811115611aba57600080fd5b604081901b9050817fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff03811115611af057600080fd5b818101925050505b92915050565b6000600c60003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060000154611b95600354600c60003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060010154426002546111fe565b611b9f9190612732565b905090565b600080821415611bb357600080fd5b600077ffffffffffffffffffffffffffffffffffffffffffffffff8411611bf05782604085901b81611be857611be76128a2565b5b049050611d5a565b600060c09050600060c086901c90506401000000008110611c1957602081901c90506020820191505b620100008110611c3157601081901c90506010820191505b6101008110611c4857600881901c90506008820191505b60108110611c5e57600481901c90506004820191505b60048110611c7457600281901c90506002820191505b60028110611c83576001820191505b600160bf830360018703901c018260ff0387901b81611ca557611ca46128a2565b5b0492506fffffffffffffffffffffffffffffffff831115611cc557600080fd5b6000608086901c8402905060006fffffffffffffffffffffffffffffffff871685029050600060c089901c9050600060408a901b905082811015611d0a576001820391505b8281039050608084901b925082811015611d25576001820391505b8281039050608084901c8214611d3e57611d3d612844565b5b888181611d4e57611d4d6128a2565b5b04870196505050505050505b6fffffffffffffffffffffffffffffffff811115611d7757600080fd5b8091505092915050565b5080546000825590600052602060002090810190611d9f9190611def565b50565b828054828255906000526020600020908101928215611dde579160200282015b82811115611ddd578251825591602001919060010190611dc2565b5b509050611deb9190611def565b5090565b5b80821115611e08576000816000905550600101611df0565b5090565b6000611e1f611e1a8461266e565b612649565b90508083825260208201905082856020860282011115611e4257611e41612934565b5b60005b85811015611e725781611e588882611ed4565b845260208401935060208301925050600181019050611e45565b5050509392505050565b600081359050611e8b81612ca5565b92915050565b600082601f830112611ea657611ea561292f565b5b8135611eb6848260208601611e0c565b91505092915050565b600081519050611ece81612cbc565b92915050565b600081359050611ee381612cd3565b92915050565b600081359050611ef881612cea565b92915050565b600060208284031215611f1457611f1361293e565b5b6000611f2284828501611e7c565b91505092915050565b600060208284031215611f4157611f4061293e565b5b6000611f4f84828501611ebf565b91505092915050565b600060208284031215611f6e57611f6d61293e565b5b6000611f7c84828501611ee9565b91505092915050565b60008060008060808587031215611f9f57611f9e61293e565b5b6000611fad87828801611ee9565b9450506020611fbe87828801611ee9565b9350506040611fcf87828801611ee9565b9250506060611fe087828801611ee9565b91505092959194509250565b60008060008060008060c087890312156120095761200861293e565b5b600061201789828a01611ee9565b965050602061202889828a01611ee9565b955050604061203989828a01611ee9565b945050606061204a89828a01611ee9565b935050608061205b89828a01611ee9565b92505060a087013567ffffffffffffffff81111561207c5761207b612939565b5b61208889828a01611e91565b9150509295509295509295565b61209e81612766565b82525050565b6120ad81612778565b82525050565b6120bc81612784565b82525050565b6120cb816127b8565b82525050565b60006120de60198361269a565b91506120e982612954565b602082019050919050565b600061210160108361269a565b915061210c8261297d565b602082019050919050565b6000612124601c8361269a565b915061212f826129a6565b602082019050919050565b600061214760208361269a565b9150612152826129cf565b602082019050919050565b600061216a601c8361269a565b9150612175826129f8565b602082019050919050565b600061218d60128361269a565b915061219882612a21565b602082019050919050565b60006121b060218361269a565b91506121bb82612a4a565b604082019050919050565b60006121d3601c8361269a565b91506121de82612a99565b602082019050919050565b60006121f660258361269a565b915061220182612ac2565b604082019050919050565b6000612219601b8361269a565b915061222482612b11565b602082019050919050565b600061223c601a8361269a565b915061224782612b3a565b602082019050919050565b600061225f602a8361269a565b915061226a82612b63565b604082019050919050565b600061228260178361269a565b915061228d82612bb2565b602082019050919050565b60006122a560148361269a565b91506122b082612bdb565b602082019050919050565b60006122c860358361269a565b91506122d382612c04565b604082019050919050565b60006122eb600f8361269a565b91506122f682612c53565b602082019050919050565b600061230e601c8361269a565b915061231982612c7c565b602082019050919050565b61232d816127ae565b82525050565b60006020820190506123486000830184612095565b92915050565b60006060820190506123636000830186612095565b61237060208301856120b3565b61237d60408301846120c2565b949350505050565b600060208201905061239a60008301846120a4565b92915050565b600060208201905081810360008301526123b9816120d1565b9050919050565b600060208201905081810360008301526123d9816120f4565b9050919050565b600060208201905081810360008301526123f981612117565b9050919050565b600060208201905081810360008301526124198161213a565b9050919050565b600060208201905081810360008301526124398161215d565b9050919050565b6000602082019050818103600083015261245981612180565b9050919050565b60006020820190508181036000830152612479816121a3565b9050919050565b60006020820190508181036000830152612499816121c6565b9050919050565b600060208201905081810360008301526124b9816121e9565b9050919050565b600060208201905081810360008301526124d98161220c565b9050919050565b600060208201905081810360008301526124f98161222f565b9050919050565b6000602082019050818103600083015261251981612252565b9050919050565b6000602082019050818103600083015261253981612275565b9050919050565b6000602082019050818103600083015261255981612298565b9050919050565b60006020820190508181036000830152612579816122bb565b9050919050565b60006020820190508181036000830152612599816122de565b9050919050565b600060208201905081810360008301526125b981612301565b9050919050565b60006020820190506125d56000830184612324565b92915050565b60006040820190506125f06000830185612324565b6125fd6020830184612324565b9392505050565b60006080820190506126196000830187612324565b6126266020830186612324565b6126336040830185612324565b6126406060830184612324565b95945050505050565b6000612653612664565b905061265f82826127ca565b919050565b6000604051905090565b600067ffffffffffffffff82111561268957612688612900565b5b602082029050602081019050919050565b600082825260208201905092915050565b60006126b6826127ae565b91506126c1836127ae565b9250827fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff038211156126f6576126f5612873565b5b828201905092915050565b600061270c826127ae565b9150612717836127ae565b925082612727576127266128a2565b5b828204905092915050565b600061273d826127ae565b9150612748836127ae565b92508282101561275b5761275a612873565b5b828203905092915050565b60006127718261278e565b9050919050565b60008115159050919050565b6000819050919050565b600073ffffffffffffffffffffffffffffffffffffffff82169050919050565b6000819050919050565b60006127c3826127ae565b9050919050565b6127d382612943565b810181811067ffffffffffffffff821117156127f2576127f1612900565b5b80604052505050565b6000612806826127ae565b91507fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff82141561283957612838612873565b5b600182019050919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052600160045260246000fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601160045260246000fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601260045260246000fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052603260045260246000fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b600080fd5b600080fd5b600080fd5b600080fd5b6000601f19601f8301169050919050565b7f5374616b696e67506f6f6c3a204e6f74206120706174726f6e00000000000000600082015250565b7f6861726443617020657863656564656400000000000000000000000000000000600082015250565b7f43616e6e6f74207465726d696e61746520616674657220737461727400000000600082015250565b7f5374616b696e6720506f6f6c20616c726561647920696e697469616c697a6564600082015250565b7f5374616b696e6720706f6f6c20616c7265616479206578706972656400000000600082015250565b7f4e6f2066756e647320617661696c61626c650000000000000000000000000000600082015250565b7f4475726174696f6e2073686f756c64206265206174206c65617374203120646160008201527f7900000000000000000000000000000000000000000000000000000000000000602082015250565b7f5374616b696e6720506f6f6c206e6f7420696e697469616c697a656400000000600082015250565b7f5374616b652067726561746572207468616e20636f6e747269627574696f6e2060008201527f6c696d6974000000000000000000000000000000000000000000000000000000602082015250565b7f52657761726473206c6f776572207468616e2065787065637465640000000000600082015250565b7f43616e6e6f74207377656570206265666f726520657870697279000000000000600082015250565b7f5265717565737465642076616c75652061626f76652074686520636f6d706f7560008201527f6e6465642066756e647300000000000000000000000000000000000000000000602082015250565b7f4f6e6c794f776e65723a204e6f7420616e206f776e6572000000000000000000600082015250565b7f5374616b696e6720706f6f6c2069732066756c6c000000000000000000000000600082015250565b7f537461727420646174652073686f756c64206265206174206c6561737420637560008201527f7272656e7420626c6f636b2074696d657374616d700000000000000000000000602082015250565b7f416c726561647920737765657065640000000000000000000000000000000000600082015250565b7f5374616b696e6720706f6f6c206e6f7420796574207374617274656400000000600082015250565b612cae81612766565b8114612cb957600080fd5b50565b612cc581612778565b8114612cd057600080fd5b50565b612cdc81612784565b8114612ce757600080fd5b50565b612cf3816127ae565b8114612cfe57600080fd5b5056fea26469706673582212206a1db1173a909e6f48c73d86c6a2bbbe88282ea89d79b2a5ef87ce4d8d1dc6c364736f6c63430008060033";
class StakingPool__factory extends ContractFactory {
  constructor(...args) {
    if (args.length === 1) {
      super(_abi$4, _bytecode$4, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(_ownerRole, _claimManager, overrides) {
    return super.deploy(_ownerRole, _claimManager, overrides || {});
  }

  getDeployTransaction(_ownerRole, _claimManager, overrides) {
    return super.getDeployTransaction(_ownerRole, _claimManager, overrides || {});
  }

  attach(address) {
    return super.attach(address);
  }

  connect(signer) {
    return super.connect(signer);
  }

  static createInterface() {
    return new utils.Interface(_abi$4);
  }

  static connect(address, signerOrProvider) {
    return new Contract(address, _abi$4, signerOrProvider);
  }

}
StakingPool__factory.bytecode = _bytecode$4;
StakingPool__factory.abi = _abi$4;

const {
  namehash: namehash$2,
  parseUnits
} = utils;
class StakingFactoryService {
  constructor(_signerService, _domainsService) {
    this._signerService = _signerService;
    this._domainsService = _domainsService;
  }

  static create(signerService, domainsService) {
    return __awaiter(this, void 0, void 0, function* () {
      const service = new StakingFactoryService(signerService, domainsService);
      return service;
    });
  }

  allServices() {
    return __awaiter(this, void 0, void 0, function* () {
      return [{
        org: yield this._domainsService.readName(namehash$2('energyweb.iam.ewc')),
        pool: chainConfigs()[this._signerService.chainId].stakingPoolFactoryAddress,
        provider: 'empty'
      }];
    });
  }

  getPool() {
    return __awaiter(this, void 0, void 0, function* () {
      return new StakingPoolService(this._signerService, chainConfigs()[this._signerService.chainId].stakingPoolFactoryAddress);
    });
  }

}
class StakingPoolService {
  constructor(signerService, address) {
    this.signerService = signerService;
    this.overrides = {
      gasPrice: parseUnits('0.01', 'gwei'),
      gasLimit: BigNumber.from(490000)
    };
    this.pool = new StakingPool__factory(StakingPool__factory.createInterface(), StakingPool__factory.bytecode).attach(address);
  }

  getStart() {
    return __awaiter(this, void 0, void 0, function* () {
      return this.pool.connect(this.signerService.signer).start();
    });
  }

  getEnd() {
    return __awaiter(this, void 0, void 0, function* () {
      return this.pool.connect(this.signerService.signer).end();
    });
  }

  getHardCap() {
    return __awaiter(this, void 0, void 0, function* () {
      return this.pool.connect(this.signerService.signer).hardCap();
    });
  }

  getContributionLimit() {
    return __awaiter(this, void 0, void 0, function* () {
      return this.pool.connect(this.signerService.signer).contributionLimit();
    });
  }

  getTotalStaked() {
    return __awaiter(this, void 0, void 0, function* () {
      return this.pool.connect(this.signerService.signer).totalStaked();
    });
  }

  getRatio() {
    return __awaiter(this, void 0, void 0, function* () {
      return this.pool.connect(this.signerService.signer).hourlyRatio();
    });
  }

  partialWithdraw(value) {
    return __awaiter(this, void 0, void 0, function* () {
      value = BigNumber.from(value);
      const transaction = yield this.pool.connect(this.signerService.signer).unstake(value);
      return transaction.wait();
    });
  }

  putStake(stake) {
    return __awaiter(this, void 0, void 0, function* () {
      stake = BigNumber.from(stake);
      const tx = {
        to: this.pool.address,
        from: this.signerService.address,
        data: this.pool.interface.encodeFunctionData('stake'),
        value: stake
      };
      const balance = yield this.signerService.balance();
      const gasPrice = yield this.signerService.signer.getGasPrice();
      const gas = yield this.signerService.provider.estimateGas(tx);
      const fee = gasPrice.mul(gas).mul(2);
      const maxStake = balance.sub(fee);

      if (maxStake.lte(0)) {
        throw new Error(ERROR_MESSAGES.INSUFFICIENT_BALANCE);
      }

      tx.value = stake.lt(maxStake) ? stake : maxStake;
      yield this.signerService.send(tx);
    });
  }

  checkReward() {
    return __awaiter(this, void 0, void 0, function* () {
      const [staked, compounded] = yield this.pool.connect(this.signerService.signer).total();
      return compounded.sub(staked);
    });
  }

  getStake() {
    return __awaiter(this, void 0, void 0, function* () {
      const [staked] = yield this.pool.connect(this.signerService.signer).total();
      const [start, end] = yield Promise.all([this.pool.connect(this.signerService.signer).start(), this.pool.connect(this.signerService.signer).end()]);
      const stakeStatus = staked.gt(0) ? StakeStatus.STAKING : StakeStatus.NONSTAKING;
      return {
        amount: staked,
        depositStart: start,
        depositEnd: end,
        status: stakeStatus
      };
    });
  }

  withdraw() {
    return __awaiter(this, void 0, void 0, function* () {
      const tx = Object.assign({
        to: this.pool.address,
        data: this.pool.interface.encodeFunctionData('unstakeAll')
      }, this.overrides);
      yield this.signerService.send(tx);
    });
  }

}

const {
  JsonRpcProvider
} = providers;
class DidRegistry {
  constructor(_signerService, _cacheClient, _assetsService, _ipfsUrl = 'https://ipfs.infura.io:5001/api/v0/') {
    this._signerService = _signerService;
    this._cacheClient = _cacheClient;
    this._assetsService = _assetsService;
    this._ipfsUrl = _ipfsUrl;

    this._signerService.onInit(this.init.bind(this));
  }

  static connect(signerService, cacheClient, assetsService, ipfsUrl) {
    return __awaiter(this, void 0, void 0, function* () {
      const registry = new DidRegistry(signerService, cacheClient, assetsService, ipfsUrl);
      yield registry.init();
      return registry;
    });
  }

  get jwt() {
    return this._jwt;
  }

  get ipfsStore() {
    return this._ipfsStore;
  }

  init() {
    return __awaiter(this, void 0, void 0, function* () {
      this._ipfsStore = new DidStore(this._ipfsUrl);
      yield this._setOperator();
      this.setJWT();
      yield this._setDocument();

      this._setClaims();
    });
  }

  getDidDocument({
    did = this._did,
    includeClaims = true
  } = {}) {
    var _a;

    return __awaiter(this, void 0, void 0, function* () {
      if (this._cacheClient) {
        try {
          const didDoc = yield this._cacheClient.getDidDocument(did, includeClaims);
          return Object.assign(Object.assign({}, didDoc), {
            service: didDoc.service
          });
        } catch (err) {
          if (((_a = err.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
            throw err;
          }

          console.log(err);
        }
      }

      const document = yield this._operator.read(did);
      return Object.assign(Object.assign({}, document), {
        service: includeClaims ? yield this.downloadClaims({
          services: document.service && document.service.length > 0 ? document.service : []
        }) : []
      });
    });
  }

  createPublicClaim({
    data,
    subject
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      if (subject) {
        return this._userClaims.createPublicClaim(data, {
          subject,
          issuer: ''
        });
      }

      return this._userClaims.createPublicClaim(data);
    });
  }

  issuePublicClaim({
    token,
    publicClaim
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      if (publicClaim) {
        return this._issuerClaims.issuePublicClaim(publicClaim);
      }

      if (token) {
        return this._issuerClaims.issuePublicClaim(token);
      }

      throw new Error('unable to issue Public Claim');
    });
  }

  verifyPublicClaim(token, iss) {
    return __awaiter(this, void 0, void 0, function* () {
      const issuerDoc = yield this.getDidDocument({
        did: iss,
        includeClaims: true
      });
      const verifier = new ProofVerifier(issuerDoc);
      return verifier.verifyAssertionProof(token);
    });
  }

  updateDocument({
    didAttribute,
    data,
    validity,
    did = this._signerService.did
  }) {
    var _a;

    return __awaiter(this, void 0, void 0, function* () {
      if (did === this._signerService.did) {
        const updated = yield this._document.update(didAttribute, data, validity);
        return Boolean(updated);
      } else {
        const assetDID = (_a = (yield this._assetsService.getOwnedAssets()).find(a => a.document.id === did)) === null || _a === void 0 ? void 0 : _a.id;

        if (!assetDID) {
          throw new Error(ERROR_MESSAGES.CAN_NOT_UPDATE_NOT_CONTROLLED_DOCUMENT);
        }

        const updateData = Object.assign({
          algo: KeyType.Secp256k1,
          encoding: Encoding.HEX
        }, data);

        const {
          didRegistryAddress: didContractAddress
        } = chainConfigs()[this._signerService.chainId];

        const operator = new ProxyOperator(this._identityOwner, {
          address: didContractAddress
        }, addressOf(assetDID));
        const update = yield operator.update(assetDID, didAttribute, updateData);
        return Boolean(update);
      }
    });
  }

  createDocument() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._cacheClient) {
        const cachedDoc = yield this._cacheClient.getDidDocument(this._did);
        const pubKey = cachedDoc.publicKey.find(pk => pk.id.endsWith(KeyTags.OWNER));

        if (!pubKey) {
          return this._document.create();
        }

        return true;
      }

      return this._document.create();
    });
  }

  revokeDidDocument() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this._document.deactivate();
      return true;
    });
  }

  decodeJWTToken({
    token
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      return this._jwt.decode(token);
    });
  }

  _setOperator() {
    return __awaiter(this, void 0, void 0, function* () {
      const signer = this._signerService.signer;
      const provider = signer.provider;
      const publicKey = yield this._signerService.publicKey();

      if (signer instanceof Wallet && provider instanceof JsonRpcProvider) {
        this._identityOwner = EwSigner.fromPrivateKey(signer.privateKey, {
          type: ProviderTypes.HTTP,
          uriOrInfo: provider.connection.url
        });
      } else if (provider instanceof JsonRpcProvider) {
        this._identityOwner = EwSigner.fromEthersSigner(signer, publicKey);
      } else {
        throw new Error(ERROR_MESSAGES.UNKNOWN_PROVIDER);
      }

      this._did = `did:${Methods.Erc1056}:${this._signerService.chainName()}:${yield signer.getAddress()}`;

      const address = chainConfigs()[this._signerService.chainId].didRegistryAddress;

      this._operator = new Operator(this._identityOwner, {
        address
      });
    });
  }

  setJWT() {
    this._jwt = new JWT(this._identityOwner);
  }

  _setDocument() {
    return __awaiter(this, void 0, void 0, function* () {
      this._document = new DIDDocumentFull(this._did, this._operator);
    });
  }

  _setClaims() {
    this._userClaims = new ClaimsUser(this._identityOwner, this._document, this._ipfsStore);
    this._issuerClaims = new ClaimsIssuer(this._identityOwner, this._document, this._ipfsStore);
  }

  downloadClaims({
    services
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      return Promise.all(services.map(_a => {
        var _b;

        return __awaiter(this, void 0, void 0, function* () {
          var {
            serviceEndpoint
          } = _a,
              rest = __rest(_a, ["serviceEndpoint"]);

          const data = yield this._ipfsStore.get(serviceEndpoint);

          const _c = (_b = this._jwt) === null || _b === void 0 ? void 0 : _b.decode(data),
                {
            claimData
          } = _c,
                claimRest = __rest(_c, ["claimData"]);

          return Object.assign(Object.assign(Object.assign({
            serviceEndpoint
          }, rest), claimData), claimRest);
        });
      }));
    });
  }

}

var MessagingMethod;

(function (MessagingMethod) {
  MessagingMethod["Nats"] = "nats";
})(MessagingMethod || (MessagingMethod = {}));

const messagingConfig = {
  [VOLTA_CHAIN_ID]: {
    messagingMethod: MessagingMethod.Nats,
    natsServerUrl: 'https://volta-identityevents.energyweb.org/',
    natsEnvironmentName: 'ewf-volta'
  }
};
const setMessagingConfig = (chainId, options) => {
  messagingConfig[chainId] = Object.assign(Object.assign({}, messagingConfig[chainId]), options);
};
const getMessagingConfig = () => Object.assign({}, messagingConfig);

class MessagingService {
  constructor(_signerService) {
    this._signerService = _signerService;
    this._subscriptions = [];

    this._signerService.onInit(this.init.bind(this));
  }

  static create(signerService) {
    return __awaiter(this, void 0, void 0, function* () {
      const service = new MessagingService(signerService);
      yield service.init();
      return service;
    });
  }

  init() {
    return __awaiter(this, void 0, void 0, function* () {
      if (executionEnvironment() === ExecutionEnvironment.NODE) {
        return;
      }

      const {
        messagingMethod,
        natsServerUrl,
        natsEnvironmentName
      } = getMessagingConfig()[this._signerService.chainId];

      if (natsServerUrl && messagingMethod === MessagingMethod.Nats) {
        this._natsEnvironmentName = natsEnvironmentName;
        this._jsonCodec = JSONCodec();

        try {
          const timeout = 3000;
          const connection = yield Promise.race([connect({
            servers: natsServerUrl.replace('http', 'ws'),
            timeout,
            pingInterval: 50 * 1000,
            reconnect: true,
            waitOnFirstConnect: true,
            verbose: true,
            maxReconnectAttempts: -1
          }), new Promise(resolve => setTimeout(resolve, timeout))]);
          if (!connection) return;
          this._natsConnection = connection;
        } catch (err) {
          console.log(err);
        }
      }
    });
  }

  subscribeTo({
    subject = `*.*.${this._signerService.did}.${this._natsEnvironmentName}`,
    messageHandler
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this._natsConnection) {
        return;
      }

      const subscription = this._natsConnection.subscribe(subject, {
        callback: (err, msg) => {
          var _a;

          if (err) {
            console.error(`Nats error:${err.message}`);
            return;
          }

          const decodedMessage = (_a = this._jsonCodec) === null || _a === void 0 ? void 0 : _a.decode(msg.data);
          messageHandler(decodedMessage);
        }
      });

      this._subscriptions.push(subscription);

      return subscription.getID();
    });
  }

  unsubscribeFrom(subscriptionId) {
    return __awaiter(this, void 0, void 0, function* () {
      const i = this._subscriptions.findIndex(s => s.getID() === subscriptionId);

      if (i !== -1) {
        this._subscriptions.splice(i, 1)[0].unsubscribe();
      }
    });
  }

  publish(subject, data) {
    var _a;

    return __awaiter(this, void 0, void 0, function* () {
      (_a = this._natsConnection) === null || _a === void 0 ? void 0 : _a.publish(subject, data);
    });
  }

}

const cacheConfig = {
  [VOLTA_CHAIN_ID$1]: {
    url: 'https://volta-identitycache.energyweb.org/v1/',
    cacheServerSupportsAuth: true
  },
  [EWC_CHAIN_ID]: {
    url: 'https://identitycache.energyweb.org/v1/',
    cacheServerSupportsAuth: true
  }
};
const setCacheConfig = (chainId, options) => {
  cacheConfig[chainId] = Object.assign(Object.assign({}, cacheConfig[chainId]), options);
};
const cacheConfigs = () => Object.assign({}, cacheConfig);

var Order;

(function (Order) {
  Order["ASC"] = "ASC";
  Order["DESC"] = "DESC";
})(Order || (Order = {}));

var SearchType;

(function (SearchType) {
  SearchType["App"] = "App";
  SearchType["Org"] = "Org";
  SearchType["Role"] = "Role";
})(SearchType || (SearchType = {}));

const TEST_LOGIN_ENDPOINT = '/auth/status';

class CacheClient {
  constructor(_signerService) {
    this._signerService = _signerService;
    this.isAuthenticating = false;
    this.failedRequests = [];

    this._signerService.onInit(this.init.bind(this));
  }

  init() {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        url,
        cacheServerSupportsAuth = false
      } = cacheConfigs()[this._signerService.chainId];

      this.httpClient = axios.create({
        baseURL: url,
        withCredentials: true
      });
      this.httpClient.interceptors.response.use(response => {
        return response;
      }, this.handleError.bind(this));
      this.authEnabled = cacheServerSupportsAuth;
      this.isBrowser = executionEnvironment() === ExecutionEnvironment.BROWSER;
    });
  }

  isAuthEnabled() {
    return this.authEnabled;
  }

  authenticate() {
    return __awaiter(this, void 0, void 0, function* () {
      try {
        const {
          refreshToken,
          token
        } = yield this.refreshToken();

        if (!this.isBrowser) {
          this.httpClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        }

        if (yield this.isAuthenticated()) {
          this.refresh_token = refreshToken;
          return;
        }
      } catch (_a) {}

      const pubKeyAndIdentityToken = yield this._signerService.publicKeyAndIdentityToken();
      const {
        data: {
          refreshToken,
          token
        }
      } = yield this.httpClient.post('/login', {
        identityToken: pubKeyAndIdentityToken.identityToken
      });

      if (!this.isBrowser) {
        this.httpClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      }

      this.refresh_token = refreshToken;
      this.pubKeyAndIdentityToken = pubKeyAndIdentityToken;
      this.failedRequests = this.failedRequests.filter(callback => callback());
    });
  }

  handleError(error) {
    var _a, _b, _c;

    return __awaiter(this, void 0, void 0, function* () {
      const {
        config,
        response
      } = error;
      const originalRequest = config;

      if (this.authEnabled && response && (response.status === 401 || response.status === 403) && config && ((_a = config.url) === null || _a === void 0 ? void 0 : _a.indexOf('/login')) === -1 && ((_b = config.url) === null || _b === void 0 ? void 0 : _b.indexOf('/refresh_token')) === -1 && ((_c = config.url) === null || _c === void 0 ? void 0 : _c.indexOf(TEST_LOGIN_ENDPOINT)) === -1) {
        const retryOriginalRequest = new Promise(resolve => {
          this.failedRequests.push(() => {
            resolve(axios(originalRequest));
          });
        });

        if (!this.isAuthenticating) {
          this.isAuthenticating = true;
          yield this.authenticate();
          this.isAuthenticating = false;
        }

        return retryOriginalRequest;
      }

      return Promise.reject(error);
    });
  }

  login() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!(yield this.isAuthenticated())) {
        yield this.authenticate();
      }
    });
  }

  getRoleDefinition(namespace) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        data
      } = yield this.httpClient.get(`/role/${namespace}`);
      return data === null || data === void 0 ? void 0 : data.definition;
    });
  }

  getRolesDefinition(namespaces) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        data
      } = yield this.httpClient.get(`/role?namespaces=${namespaces.join(',')}`);
      const rolesWithDefinitions = data === null || data === void 0 ? void 0 : data.map(entry => ({
        definition: entry.definition,
        role: entry.namespace
      }));
      return rolesWithDefinitions.reduce((result, {
        role,
        definition
      }) => {
        return Object.assign(Object.assign({}, result), {
          [role]: definition
        });
      }, {});
    });
  }

  getOrgDefinition(namespace) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        data
      } = yield this.httpClient.get(`/org/${namespace}`);
      return data === null || data === void 0 ? void 0 : data.definition;
    });
  }

  getAppDefinition(namespace) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        data
      } = yield this.httpClient.get(`/app/${namespace}`);
      return data === null || data === void 0 ? void 0 : data.definition;
    });
  }

  getApplicationRoles(namespace) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        data
      } = yield this.httpClient.get(`/app/${namespace}/roles`);
      return data;
    });
  }

  getOrganizationRoles(namespace) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        data
      } = yield this.httpClient.get(`/org/${namespace}/roles`);
      return data;
    });
  }

  getOrganizationsByOwner(owner, withRelations = true) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        data
      } = yield this.httpClient.get(`/org/owner/${owner}?withRelations=${withRelations}`);
      return data;
    });
  }

  getSubOrganizationsByOrganization(namespace) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        data
      } = yield this.httpClient.get(`/org/${namespace}/suborgs`);
      return data;
    });
  }

  getOrgHierarchy(namespace) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        data
      } = yield this.httpClient.get(`/org/${namespace}`);
      return data;
    });
  }

  getNamespaceBySearchPhrase(search, types) {
    return __awaiter(this, void 0, void 0, function* () {
      if (types && types.length > 0) {
        const {
          data
        } = yield this.httpClient.get(`/search/${search}`, {
          params: {
            types
          },
          paramsSerializer: params => {
            return stringify(params, {
              arrayFormat: 'brackets'
            });
          }
        });
        return data;
      }

      const {
        data
      } = yield this.httpClient.get(`/search/${search}`);
      return data;
    });
  }

  getApplicationsByOwner(owner, withRelations = true) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        data
      } = yield this.httpClient.get(`/app/owner/${owner}?withRelations=${withRelations}`);
      return data;
    });
  }

  getApplicationsByOrganization(namespace) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        data
      } = yield this.httpClient.get(`/org/${namespace}/apps`);
      return data;
    });
  }

  getRolesByOwner(owner) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        data
      } = yield this.httpClient.get(`/role/owner/${owner}`);
      return data;
    });
  }

  getClaimsBySubjects(subjects) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        data
      } = yield this.httpClient.get('/claim/by/subjects', {
        params: {
          subjects: subjects.join(',')
        }
      });
      return data;
    });
  }

  getClaimsByIssuer(issuer, {
    isAccepted,
    namespace
  } = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        data
      } = yield this.httpClient.get(`/claim/issuer/${issuer}`, {
        params: {
          isAccepted,
          namespace
        }
      });
      return data;
    });
  }

  getClaimsByRequester(requester, {
    isAccepted,
    namespace
  } = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        data
      } = yield this.httpClient.get(`/claim/requester/${requester}`, {
        params: {
          isAccepted,
          namespace
        }
      });
      return data;
    });
  }

  getClaimsBySubject(subject, {
    isAccepted,
    namespace
  } = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        data
      } = yield this.httpClient.get(`/claim/subject/${subject}`, {
        params: {
          isAccepted,
          namespace
        }
      });
      return data;
    });
  }

  getClaimById(claimId) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        data
      } = yield this.httpClient.get(`/claim/${claimId}`);
      return data;
    });
  }

  requestClaim(message) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.httpClient.post('/claim/request', message);
    });
  }

  issueClaim(issuer, message) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.httpClient.post(`/claim/issue/${issuer}`, message);
    });
  }

  rejectClaim(issuer, message) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.httpClient.post(`/claim/reject/${issuer}`, message);
    });
  }

  deleteClaim(id) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.httpClient.delete(`/claim/${id}`);
    });
  }

  getDIDsForRole(namespace) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        data
      } = yield this.httpClient.get(`/claim/did/${namespace}?accepted=true`);
      return data;
    });
  }

  getDidDocument(did, includeClaims) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        data
      } = yield this.httpClient.get(`/DID/${did}?includeClaims=${includeClaims || false}`);
      return data;
    });
  }

  getAllowedRolesByIssuer(did) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        data
      } = yield this.httpClient.get(`/claim/issuer/roles/allowed/${did}`);
      return data;
    });
  }

  addDIDToWatchList(did) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.httpClient.post(`/DID/${did}`);
    });
  }

  getOwnedAssets(did) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        data
      } = yield this.httpClient.get(`/assets/owner/${did}`);
      return data;
    });
  }

  getOfferedAssets(did) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        data
      } = yield this.httpClient.get(`/assets/offered_to/${did}`);
      return data;
    });
  }

  getAssetById(id) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        data
      } = yield this.httpClient.get(`/assets/${id}`);
      return data;
    });
  }

  getPreviouslyOwnedAssets(owner) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        data
      } = yield this.httpClient.get(`/assets/owner/history/${owner}`);
      return data;
    });
  }

  getAssetHistory(id, {
    order,
    take,
    skip,
    type
  } = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      const query = stringify({
        order,
        take,
        skip,
        type
      }, {
        skipNulls: true
      });
      const {
        data
      } = yield this.httpClient.get(`/assets/history/${id}?${query}`);
      return data;
    });
  }

  refreshToken() {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        data
      } = yield this.httpClient.get(`/refresh_token${this.isBrowser ? '' : `?refresh_token=${this.refresh_token}`}`);
      return data;
    });
  }

  isAuthenticated() {
    return __awaiter(this, void 0, void 0, function* () {
      try {
        const {
          data
        } = yield this.httpClient.get(`${TEST_LOGIN_ENDPOINT}`);
        return data.user ? data.user === this._signerService.did : false;
      } catch (_) {
        return false;
      }
    });
  }

}

const _abi$3 = [{
  inputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "node",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "label",
    type: "bytes32"
  }, {
    indexed: false,
    internalType: "bool",
    name: "owner",
    type: "address"
  }],
  name: "NewOwner",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    indexed: false,
    internalType: "bytes32",
    name: "owner",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "owner",
    type: "address"
  }],
  name: "Transfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    indexed: false,
    internalType: "address",
    name: "resolver",
    type: "address"
  }],
  name: "NewResolver",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    indexed: false,
    internalType: "uint64",
    name: "ttl",
    type: "uint64"
  }],
  name: "NewTTL",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "owner",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "operator",
    type: "address"
  }, {
    indexed: false,
    name: "approved",
    type: "bool"
  }],
  name: "ApprovalForAll",
  type: "event"
}, {
  constant: false,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    internalType: "address",
    name: "resolver",
    type: "address"
  }, {
    internalType: "uint64",
    name: "ttl",
    type: "uint64"
  }],
  name: "setRecord",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    internalType: "bytes32",
    name: "label",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    internalType: "address",
    name: "resolver",
    type: "address"
  }, {
    internalType: "uint64",
    name: "ttl",
    type: "uint64"
  }],
  name: "setSubnodeRecord",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "owner",
    type: "address"
  }],
  name: "setOwner",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    internalType: "bytes32",
    name: "label",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "owner",
    type: "address"
  }],
  name: "setSubnodeOwner",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "resolver",
    type: "address"
  }],
  name: "setResolver",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    internalType: "uint64",
    name: "ttl",
    type: "uint64"
  }],
  name: "setTTL",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "address",
    name: "operator",
    type: "address"
  }, {
    internalType: "bool",
    name: "approved",
    type: "bool"
  }],
  name: "setApprovalForAll",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }],
  name: "owner",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }],
  name: "resolver",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }],
  name: "ttl",
  outputs: [{
    internalType: "uint64",
    name: "",
    type: "uint64"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }],
  name: "recordExists",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    internalType: "address",
    name: "operator",
    type: "address"
  }],
  name: "isApprovedForAll",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}];
const _bytecode$3 = "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";
class ENSRegistry__factory extends ContractFactory {
  constructor(...args) {
    if (args.length === 1) {
      super(_abi$3, _bytecode$3, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(overrides) {
    return super.deploy(overrides || {});
  }

  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }

  attach(address) {
    return super.attach(address);
  }

  connect(signer) {
    return super.connect(signer);
  }

  static createInterface() {
    return new utils.Interface(_abi$3);
  }

  static connect(address, signerOrProvider) {
    return new Contract(address, _abi$3, signerOrProvider);
  }

}
ENSRegistry__factory.bytecode = _bytecode$3;
ENSRegistry__factory.abi = _abi$3;

const sha3 = require('js-sha3').keccak_256;
function decodeLabelhash(hash) {
  if (!(hash.startsWith('[') && hash.endsWith(']'))) {
    throw Error('Expected encoded labelhash to start and end with square brackets');
  }

  if (hash.length !== 66) {
    throw Error('Expected encoded labelhash to have a length of 66');
  }

  return `${hash.slice(1, -1)}`;
}
function isEncodedLabelhash(hash) {
  return hash.startsWith('[') && hash.endsWith(']') && hash.length === 66;
}
function labelhash(unnormalizedLabelOrLabelhash) {
  return isEncodedLabelhash(unnormalizedLabelOrLabelhash) ? '0x' + decodeLabelhash(unnormalizedLabelOrLabelhash) : '0x' + sha3(normalize(unnormalizedLabelOrLabelhash));
}

var RegistrationTypes;

(function (RegistrationTypes) {
  RegistrationTypes["OffChain"] = "RegistrationTypes::OffChain";
  RegistrationTypes["OnChain"] = "RegistrationTypes::OnChain";
})(RegistrationTypes || (RegistrationTypes = {}));

var ClaimEventType;

(function (ClaimEventType) {
  ClaimEventType["ISSUE_CREDENTIAL"] = "issue-credential";
  ClaimEventType["REJECT_CREDENTIAL"] = "reject-credential";
  ClaimEventType["REQUEST_CREDENTIALS"] = "request-credential";
})(ClaimEventType || (ClaimEventType = {}));

const readyToBeRegisteredOnchain = claim => {
  const requiredProps = ['claimType', 'claimTypeVersion', 'subject', 'onChainProof', 'acceptedBy', 'subjectAgreement'];
  const claimProps = Object.keys(claim);
  return requiredProps.every(p => claimProps.includes(p));
};
const typedMsgPrefix = '1901';
const erc712_type_hash = utils.id('EIP712Domain(string name,string version,uint256 chainId,address verifyingContract)');
const agreement_type_hash = utils.id('Agreement(address subject,bytes32 role,uint256 version)');
const proof_type_hash = utils.id('Proof(address subject,bytes32 role,uint256 version,uint256 expiry,address issuer)');
const defaultClaimExpiry = Number.MAX_SAFE_INTEGER - 1;

var NamespaceType;

(function (NamespaceType) {
  NamespaceType["Role"] = "roles";
  NamespaceType["Application"] = "apps";
  NamespaceType["Organization"] = "org";
})(NamespaceType || (NamespaceType = {}));

const NODE_FIELDS_KEY = 'metadata';

function validateAddress(address) {
  utils.getAddress(address);
}

const {
  namehash: namehash$1
} = utils;
class DomainsService {
  constructor(_signerService, _cacheClient) {
    this._signerService = _signerService;
    this._cacheClient = _cacheClient;
    this._ttl = BigNumber.from(0);

    this._signerService.onInit(this.init.bind(this));
  }

  static create(signerService, cacheClient) {
    return __awaiter(this, void 0, void 0, function* () {
      const service = new DomainsService(signerService, cacheClient);
      yield service.init();
      return service;
    });
  }

  init() {
    return __awaiter(this, void 0, void 0, function* () {
      const chainId = this._signerService.chainId;
      this.chainId = chainId;
      const provider = this._signerService.provider;
      const {
        ensRegistryAddress,
        ensResolverAddress,
        ensPublicResolverAddress,
        domainNotifierAddress
      } = chainConfigs()[this.chainId];
      this._ensRegistryAddress = ensRegistryAddress;
      this._ensResolverAddress = ensResolverAddress;
      this._ensPublicResolverAddress = ensPublicResolverAddress;
      this._ensRegistry = new ENSRegistry__factory(ENSRegistry__factory.createInterface(), ENSRegistry__factory.bytecode).attach(ensRegistryAddress).connect(provider);
      this._domainDefinitionReader = new DomainReader({
        ensRegistryAddress,
        provider
      });
      ensPublicResolverAddress && this._domainDefinitionReader.addKnownResolver({
        chainId,
        address: ensPublicResolverAddress,
        type: ResolverContractType.PublicResolver
      });
      ensResolverAddress && this._domainDefinitionReader.addKnownResolver({
        chainId,
        address: ensResolverAddress,
        type: ResolverContractType.RoleDefinitionResolver_v1
      });
      this._domainDefinitionTransactionFactory = new DomainTransactionFactory({
        domainResolverAddress: ensResolverAddress
      });
      this._domainHierarchy = new DomainHierarchy({
        domainReader: this._domainDefinitionReader,
        ensRegistryAddress: this._ensRegistryAddress,
        provider,
        domainNotifierAddress: domainNotifierAddress,
        publicResolverAddress: ensPublicResolverAddress
      });
      this._owner = this._signerService.address;
    });
  }

  setRoleDefinition({
    domain,
    data
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      if (yield this.updateLegacyDefinition(domain, data)) {
        return;
      }

      yield this._signerService.send(Object.assign({}, this._domainDefinitionTransactionFactory.editDomain({
        domain,
        domainDefinition: data
      })));
    });
  }

  createOrganization({
    orgName,
    namespace,
    data,
    returnSteps
  }) {
    var e_1, _a;

    return __awaiter(this, void 0, void 0, function* () {
      const orgDomain = `${orgName}.${namespace}`;
      const rolesDomain = `${NamespaceType.Role}.${orgDomain}`;
      const appsDomain = `${NamespaceType.Application}.${orgDomain}`;

      if (!(yield this.isOwner({
        domain: namespace,
        user: this._owner
      }))) {
        throw new Error(ERROR_MESSAGES.NOT_AUTHORIZED_TO_CHANGE_DOMAIN);
      }

      const steps = [{
        tx: this.createSubdomainTx({
          domain: namespace,
          nodeName: orgName,
          owner: this._owner
        }),
        info: 'Create organization subdomain'
      }, {
        tx: this._domainDefinitionTransactionFactory.newDomain({
          domain: orgDomain,
          domainDefinition: data
        }),
        info: 'Register reverse name and set definition for organization subdomain'
      }, {
        tx: this.createSubdomainTx({
          domain: orgDomain,
          nodeName: NamespaceType.Role,
          owner: this._owner
        }),
        info: 'Create roles subdomain for organization'
      }, {
        tx: this._domainDefinitionTransactionFactory.setDomainNameTx({
          domain: rolesDomain
        }),
        info: 'Register reverse name for roles subdomain'
      }, {
        tx: this.createSubdomainTx({
          domain: orgDomain,
          nodeName: NamespaceType.Application,
          owner: this._owner
        }),
        info: 'Create app subdomain for organization'
      }, {
        tx: this._domainDefinitionTransactionFactory.setDomainNameTx({
          domain: appsDomain
        }),
        info: 'Register reverse name for app subdomain'
      }].map(step => Object.assign(Object.assign({}, step), {
        next: () => __awaiter(this, void 0, void 0, function* () {
          yield this._signerService.send(Object.assign({}, step.tx));
        })
      }));

      if (returnSteps) {
        return steps;
      } else {
        try {
          for (var steps_1 = __asyncValues(steps), steps_1_1; steps_1_1 = yield steps_1.next(), !steps_1_1.done;) {
            const step = steps_1_1.value;
            yield step.next();
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (steps_1_1 && !steps_1_1.done && (_a = steps_1.return)) yield _a.call(steps_1);
          } finally {
            if (e_1) throw e_1.error;
          }
        }

        return;
      }
    });
  }

  createApplication({
    appName,
    namespace: domain,
    data,
    returnSteps
  }) {
    var e_2, _a;

    return __awaiter(this, void 0, void 0, function* () {
      const appDomain = `${appName}.${domain}`;
      const from = yield this.getOwner({
        namespace: domain
      });
      const steps = [{
        tx: this.createSubdomainTx({
          domain,
          nodeName: appName,
          owner: from
        }),
        info: 'Set subdomain for application'
      }, {
        tx: this._domainDefinitionTransactionFactory.newDomain({
          domainDefinition: data,
          domain: appDomain
        }),
        info: 'Set name definition for application'
      }, {
        tx: this.createSubdomainTx({
          domain: appDomain,
          nodeName: NamespaceType.Role,
          owner: from
        }),
        info: 'Create roles subdomain for application'
      }, {
        tx: this._domainDefinitionTransactionFactory.setDomainNameTx({
          domain: `${NamespaceType.Role}.${appDomain}`
        }),
        info: 'Set name for roles subdomain for application'
      }].map(step => Object.assign(Object.assign({}, step), {
        next: () => __awaiter(this, void 0, void 0, function* () {
          yield this._signerService.send(step.tx);
        })
      }));

      if (returnSteps) {
        return steps;
      }

      try {
        for (var steps_2 = __asyncValues(steps), steps_2_1; steps_2_1 = yield steps_2.next(), !steps_2_1.done;) {
          const step = steps_2_1.value;
          yield step.next();
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (steps_2_1 && !steps_2_1.done && (_a = steps_2.return)) yield _a.call(steps_2);
        } finally {
          if (e_2) throw e_2.error;
        }
      }

      return;
    });
  }

  createRole({
    roleName,
    namespace,
    data,
    returnSteps
  }) {
    var e_3, _a;

    return __awaiter(this, void 0, void 0, function* () {
      const newDomain = `${roleName}.${namespace}`;
      const from = yield this.getOwner({
        namespace
      });
      const steps = [{
        tx: this.createSubdomainTx({
          domain: namespace,
          nodeName: roleName,
          owner: from
        }),
        info: 'Create subdomain for role'
      }, {
        tx: this._domainDefinitionTransactionFactory.newRole({
          domain: newDomain,
          roleDefinition: data
        }),
        info: 'Set name and definition for role'
      }].map(step => Object.assign(Object.assign({}, step), {
        next: () => __awaiter(this, void 0, void 0, function* () {
          yield this._signerService.send(step.tx);
        })
      }));

      if (returnSteps) {
        return steps;
      }

      try {
        for (var steps_3 = __asyncValues(steps), steps_3_1; steps_3_1 = yield steps_3.next(), !steps_3_1.done;) {
          const step = steps_3_1.value;
          yield step.next();
        }
      } catch (e_3_1) {
        e_3 = {
          error: e_3_1
        };
      } finally {
        try {
          if (steps_3_1 && !steps_3_1.done && (_a = steps_3.return)) yield _a.call(steps_3);
        } finally {
          if (e_3) throw e_3.error;
        }
      }

      return;
    });
  }

  readName(namehash) {
    return __awaiter(this, void 0, void 0, function* () {
      return this._domainDefinitionReader.readName(namehash);
    });
  }

  changeOrgOwnership({
    namespace,
    newOwner,
    returnSteps = false,
    withSubdomains = false
  }) {
    var e_4, _a, e_5, _b;

    return __awaiter(this, void 0, void 0, function* () {
      DomainsService.validateOwnerAddress(newOwner);
      const orgNamespaces = [`${NamespaceType.Role}.${namespace}`, `${NamespaceType.Application}.${namespace}`, namespace];
      const {
        alreadyFinished,
        changeOwnerNamespaces,
        notOwnedNamespaces
      } = yield this.validateChangeOwnership({
        newOwner,
        namespaces: orgNamespaces
      });

      if (notOwnedNamespaces.length > 0) {
        throw new ChangeOwnershipNotPossibleError({
          namespace,
          notOwnedNamespaces
        });
      }

      const apps = yield this.getAppsOfOrg(namespace);

      if (apps && apps.length > 0) {
        if (!withSubdomains) {
          throw new Error('You are not able to change ownership of organization with registered apps');
        } else {
          try {
            for (var apps_1 = __asyncValues(apps), apps_1_1; apps_1_1 = yield apps_1.next(), !apps_1_1.done;) {
              const {
                namespace
              } = apps_1_1.value;
              yield this.changeAppOwnership({
                namespace,
                newOwner,
                returnSteps
              });
            }
          } catch (e_4_1) {
            e_4 = {
              error: e_4_1
            };
          } finally {
            try {
              if (apps_1_1 && !apps_1_1.done && (_a = apps_1.return)) yield _a.call(apps_1);
            } finally {
              if (e_4) throw e_4.error;
            }
          }
        }
      }

      if (alreadyFinished.length > 0) {
        console.log(`Already changed ownership of ${alreadyFinished.join(', ')}`);
      }

      const steps = changeOwnerNamespaces.map(namespace => {
        const tx = this.changeDomainOwnerTx({
          newOwner,
          namespace
        });
        return {
          tx,
          next: ({
            retryCheck
          } = {}) => __awaiter(this, void 0, void 0, function* () {
            if (retryCheck) {
              const owner = yield this.getOwner({
                namespace
              });
              if (owner === newOwner) return;
            }

            return this._signerService.send(tx);
          }),
          info: `Changing ownership of ${namespace}`
        };
      });

      if (returnSteps) {
        return steps;
      }

      try {
        for (var steps_4 = __asyncValues(steps), steps_4_1; steps_4_1 = yield steps_4.next(), !steps_4_1.done;) {
          const step = steps_4_1.value;
          yield step.next();
        }
      } catch (e_5_1) {
        e_5 = {
          error: e_5_1
        };
      } finally {
        try {
          if (steps_4_1 && !steps_4_1.done && (_b = steps_4.return)) yield _b.call(steps_4);
        } finally {
          if (e_5) throw e_5.error;
        }
      }

      return;
    });
  }

  changeAppOwnership({
    namespace,
    newOwner,
    returnSteps
  }) {
    var e_6, _a;

    return __awaiter(this, void 0, void 0, function* () {
      DomainsService.validateOwnerAddress(newOwner);
      const roles = yield this.getRolesByNamespace({
        namespace,
        parentType: NamespaceType.Application
      });
      const appNamespaces = [...roles.map(r => r.namespace), `${NamespaceType.Role}.${namespace}`, namespace];
      const {
        alreadyFinished,
        changeOwnerNamespaces,
        notOwnedNamespaces
      } = yield this.validateChangeOwnership({
        newOwner,
        namespaces: appNamespaces
      });

      if (notOwnedNamespaces.length > 0) {
        throw new ChangeOwnershipNotPossibleError({
          namespace,
          notOwnedNamespaces
        });
      }

      if (alreadyFinished.length > 0) {
        console.log(`Already changed ownership of ${alreadyFinished.join(', ')}`);
      }

      const steps = changeOwnerNamespaces.map(namespace => {
        const tx = this.changeDomainOwnerTx({
          newOwner,
          namespace
        });
        return {
          tx,
          next: ({
            retryCheck
          } = {}) => __awaiter(this, void 0, void 0, function* () {
            if (retryCheck) {
              const owner = yield this.getOwner({
                namespace
              });
              if (owner === newOwner) return;
            }

            return this._signerService.send(tx);
          }),
          info: `Changing ownership of ${namespace}`
        };
      });

      if (returnSteps) {
        return steps;
      }

      try {
        for (var steps_5 = __asyncValues(steps), steps_5_1; steps_5_1 = yield steps_5.next(), !steps_5_1.done;) {
          const step = steps_5_1.value;
          yield step.next();
        }
      } catch (e_6_1) {
        e_6 = {
          error: e_6_1
        };
      } finally {
        try {
          if (steps_5_1 && !steps_5_1.done && (_a = steps_5.return)) yield _a.call(steps_5);
        } finally {
          if (e_6) throw e_6.error;
        }
      }

      return;
    });
  }

  changeRoleOwnership({
    namespace,
    newOwner
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      DomainsService.validateOwnerAddress(newOwner);
      const notOwnedNamespaces = yield this.validateOwnership({
        namespace,
        type: NamespaceType.Role
      });

      if (notOwnedNamespaces.length > 0) {
        throw new ChangeOwnershipNotPossibleError({
          namespace,
          notOwnedNamespaces
        });
      }

      yield this._signerService.send(this.changeDomainOwnerTx({
        namespace,
        newOwner
      }));
    });
  }

  deleteOrganization({
    namespace,
    returnSteps
  }) {
    var e_7, _a;

    return __awaiter(this, void 0, void 0, function* () {
      const apps = this._cacheClient ? yield this.getAppsOfOrg(namespace) : yield this.getSubdomains({
        domain: `${NamespaceType.Application}.${namespace}`
      });

      if (apps && apps.length > 0) {
        throw new Error(ERROR_MESSAGES.ORG_WITH_APPS);
      }

      const roles = this._cacheClient ? yield this._cacheClient.getOrganizationRoles(namespace) : yield this.getSubdomains({
        domain: `${NamespaceType.Role}.${namespace}`
      });

      if (roles && roles.length > 0) {
        throw new Error(ERROR_MESSAGES.ORG_WITH_ROLES);
      }

      const orgNamespaces = [`${NamespaceType.Role}.${namespace}`, `${NamespaceType.Application}.${namespace}`, namespace];
      const {
        alreadyFinished,
        namespacesToDelete,
        notOwnedNamespaces
      } = yield this.validateDeletePossibility({
        namespaces: orgNamespaces
      });

      if (notOwnedNamespaces.length > 0) {
        throw new DeletingNamespaceNotPossibleError({
          namespace,
          notOwnedNamespaces
        });
      }

      if (alreadyFinished.length > 0) {
        console.log(`Already deleted: ${alreadyFinished.join(', ')}`);
      }

      const steps = namespacesToDelete.map(namespace => {
        const tx = this.deleteDomainTx({
          namespace
        });
        return {
          tx,
          next: ({
            retryCheck
          } = {}) => __awaiter(this, void 0, void 0, function* () {
            if (retryCheck) {
              const owner = yield this.getOwner({
                namespace
              });
              if (owner === emptyAddress) return;
            }

            return this._signerService.send(tx);
          }),
          info: `Deleting ${namespace}`
        };
      });

      if (returnSteps) {
        return steps;
      }

      try {
        for (var steps_6 = __asyncValues(steps), steps_6_1; steps_6_1 = yield steps_6.next(), !steps_6_1.done;) {
          const step = steps_6_1.value;
          yield step.next();
        }
      } catch (e_7_1) {
        e_7 = {
          error: e_7_1
        };
      } finally {
        try {
          if (steps_6_1 && !steps_6_1.done && (_a = steps_6.return)) yield _a.call(steps_6);
        } finally {
          if (e_7) throw e_7.error;
        }
      }

      return;
    });
  }

  deleteApplication({
    namespace,
    returnSteps
  }) {
    var e_8, _a;

    return __awaiter(this, void 0, void 0, function* () {
      const roles = this._cacheClient ? yield this._cacheClient.getApplicationRoles(namespace) : yield this.getSubdomains({
        domain: `${NamespaceType.Role}.${namespace}`
      });

      if (roles && roles.length > 0) {
        throw new Error(ERROR_MESSAGES.APP_WITH_ROLES);
      }

      const appNamespaces = [`${NamespaceType.Role}.${namespace}`, namespace];
      const {
        alreadyFinished,
        namespacesToDelete,
        notOwnedNamespaces
      } = yield this.validateDeletePossibility({
        namespaces: appNamespaces
      });

      if (notOwnedNamespaces.length > 0) {
        throw new DeletingNamespaceNotPossibleError({
          namespace,
          notOwnedNamespaces
        });
      }

      if (alreadyFinished.length > 0) {
        console.log(`Already deleted: ${alreadyFinished.join(', ')}`);
      }

      const steps = namespacesToDelete.map(namespace => {
        const tx = this.deleteDomainTx({
          namespace
        });
        return {
          tx,
          next: ({
            retryCheck
          } = {}) => __awaiter(this, void 0, void 0, function* () {
            if (retryCheck) {
              const owner = yield this.getOwner({
                namespace
              });
              if (owner === emptyAddress) return;
            }

            return this._signerService.send(tx);
          }),
          info: `Deleting ${namespace}`
        };
      });

      if (returnSteps) {
        return steps;
      }

      try {
        for (var steps_7 = __asyncValues(steps), steps_7_1; steps_7_1 = yield steps_7.next(), !steps_7_1.done;) {
          const step = steps_7_1.value;
          yield step.next();
        }
      } catch (e_8_1) {
        e_8 = {
          error: e_8_1
        };
      } finally {
        try {
          if (steps_7_1 && !steps_7_1.done && (_a = steps_7.return)) yield _a.call(steps_7);
        } finally {
          if (e_8) throw e_8.error;
        }
      }

      return;
    });
  }

  deleteRole({
    namespace
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      const notOwnedNamespaces = yield this.validateOwnership({
        namespace,
        type: NamespaceType.Role
      });

      if (notOwnedNamespaces.length > 0) {
        throw new DeletingNamespaceNotPossibleError({
          namespace,
          notOwnedNamespaces
        });
      }

      yield this._signerService.send(this.deleteDomainTx({
        namespace
      }));
    });
  }

  getDefinition({
    type,
    namespace
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      if (type === NamespaceType.Role) {
        return this._cacheClient.getRoleDefinition(namespace);
      }

      if (type === NamespaceType.Application) {
        return this._cacheClient.getAppDefinition(namespace);
      }

      if (type === NamespaceType.Organization) {
        return this._cacheClient.getOrgDefinition(namespace);
      }

      throw new ENSTypeNotSupportedError();
    });
  }

  getRolesByNamespace({
    parentType,
    namespace
  }) {
    if (parentType === NamespaceType.Organization) {
      return this._cacheClient.getOrganizationRoles(namespace);
    }

    if (parentType === NamespaceType.Application) {
      return this._cacheClient.getApplicationRoles(namespace);
    }

    throw new ENSTypeNotSupportedError();
  }

  getAllowedRolesByIssuer(did) {
    return this._cacheClient.getAllowedRolesByIssuer(did);
  }

  getENSTypesByOwner({
    type,
    owner,
    withRelations = true
  }) {
    DomainsService.validateOwnerAddress(owner);

    if (type === NamespaceType.Organization) {
      return this._cacheClient.getOrganizationsByOwner(owner, withRelations);
    }

    if (type === NamespaceType.Application) {
      return this._cacheClient.getApplicationsByOwner(owner, withRelations);
    }

    if (type === NamespaceType.Role) {
      return this._cacheClient.getRolesByOwner(owner);
    }

    throw new ENSTypeNotSupportedError();
  }

  getENSTypesBySearchPhrase(search, types) {
    return this._cacheClient.getNamespaceBySearchPhrase(search, types);
  }

  getAppsOfOrg(org) {
    return this._cacheClient.getApplicationsByOrganization(org);
  }

  getSubOrgsByOrgNamespace(namespace) {
    return this._cacheClient.getSubOrganizationsByOrganization(namespace);
  }

  getOrgHierarchy(namespace) {
    return __awaiter(this, void 0, void 0, function* () {
      const org = yield this._cacheClient.getOrgHierarchy(namespace);
      [org, ...(org.subOrgs || []), ...(org.apps || []), ...(org.roles || [])].forEach(domain => domain.isOwnedByCurrentUser = domain.owner === this._owner);
      return org;
    });
  }

  getDIDsByRole(role) {
    return this._cacheClient.getDIDsForRole(role);
  }

  getSubdomains({
    domain,
    mode = 'FIRSTLEVEL'
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      return this._domainHierarchy.getSubdomainsUsingResolver({
        domain,
        mode
      });
    });
  }

  checkExistenceOfDomain({
    domain
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      const domainHash = namehash$1(domain);
      const [exists, isOwned] = yield Promise.all([this._ensRegistry.recordExists(domainHash), (() => __awaiter(this, void 0, void 0, function* () {
        const owner = yield this._ensRegistry.owner(domainHash);
        return owner !== emptyAddress;
      }))()]);
      return exists && isOwned;
    });
  }

  isOwner({
    domain,
    user = this._owner
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      const domainHash = namehash$1(domain);
      const owner = yield this._ensRegistry.owner(domainHash);
      return owner === user;
    });
  }

  validateOwnership({
    namespace,
    type
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      return this.nonOwnedNodesOf({
        namespace,
        type,
        owner: this._owner
      });
    });
  }

  validateChangeOwnership({
    namespaces,
    newOwner
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      const namespacesOwners = yield this.namespacesWithRelations(namespaces);
      return namespacesOwners.reduce((acc, {
        namespace,
        owner
      }) => {
        if (owner === newOwner) {
          acc.alreadyFinished.push(namespace);
          return acc;
        }

        if (owner === emptyAddress || owner === this._owner) {
          acc.changeOwnerNamespaces.push(namespace);
          return acc;
        }

        acc.notOwnedNamespaces.push(namespace);
        return acc;
      }, {
        notOwnedNamespaces: [],
        alreadyFinished: [],
        changeOwnerNamespaces: []
      });
    });
  }

  validateDeletePossibility({
    namespaces
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      const namespacesOwners = yield this.namespacesWithRelations(namespaces);
      return namespacesOwners.reduce((acc, {
        namespace,
        owner
      }) => {
        if (owner === emptyAddress) {
          acc.alreadyFinished.push(namespace);
          return acc;
        }

        if (owner === this._owner) {
          acc.namespacesToDelete.push(namespace);
          return acc;
        }

        acc.notOwnedNamespaces.push(namespace);
        return acc;
      }, {
        notOwnedNamespaces: [],
        alreadyFinished: [],
        namespacesToDelete: []
      });
    });
  }

  updateLegacyDefinition(domain, data) {
    return __awaiter(this, void 0, void 0, function* () {
      const node = namehash$1(domain);
      const currentResolverAddress = yield this._ensRegistry.resolver(node);
      const {
        ensPublicResolverAddress,
        ensResolverAddress,
        ensRegistryAddress
      } = chainConfigs()[this.chainId];

      if (currentResolverAddress === ensPublicResolverAddress) {
        const updateResolverTransaction = {
          to: ensRegistryAddress,
          data: this._ensRegistry.interface.encodeFunctionData('setResolver', [node, ensResolverAddress])
        };
        const updateDomain = DomainReader.isRoleDefinition(data) ? this._domainDefinitionTransactionFactory.newRole({
          domain,
          roleDefinition: data
        }) : this._domainDefinitionTransactionFactory.newDomain({
          domain,
          domainDefinition: data
        });
        yield this._signerService.send(updateResolverTransaction);
        yield this._signerService.send(updateDomain);
        return true;
      }

      return false;
    });
  }

  registrationTypesOfRoles(roles) {
    var roles_1, roles_1_1;

    var e_9, _a;

    return __awaiter(this, void 0, void 0, function* () {
      const types = roles.reduce((acc, role) => Object.assign(Object.assign({}, acc), {
        [role]: new Set()
      }), {});

      try {
        for (roles_1 = __asyncValues(roles); roles_1_1 = yield roles_1.next(), !roles_1_1.done;) {
          const role = roles_1_1.value;
          const def = yield this.getDefinition({
            type: NamespaceType.Role,
            namespace: role
          });

          if (!DomainReader.isRoleDefinition(def)) {
            continue;
          }

          const resolver = yield this._ensRegistry.resolver(namehash$1(role));

          if (resolver === this._ensResolverAddress) {
            types[role].add(RegistrationTypes.OnChain);
            types[role].add(RegistrationTypes.OffChain);
          } else if (resolver === this._ensPublicResolverAddress) {
            types[role].add(RegistrationTypes.OffChain);
          }
        }
      } catch (e_9_1) {
        e_9 = {
          error: e_9_1
        };
      } finally {
        try {
          if (roles_1_1 && !roles_1_1.done && (_a = roles_1.return)) yield _a.call(roles_1);
        } finally {
          if (e_9) throw e_9.error;
        }
      }

      return types;
    });
  }

  getOwner({
    namespace
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      const node = namehash$1(namespace);
      return this._ensRegistry.owner(node);
    });
  }

  createSubdomainTx({
    domain,
    nodeName,
    owner = this._owner
  }) {
    return {
      to: this._ensRegistryAddress,
      data: this._ensRegistry.interface.encodeFunctionData('setSubnodeRecord', [namehash$1(domain), labelhash(nodeName), owner, this._ensResolverAddress, this._ttl])
    };
  }

  changeSubdomainOwnerTx({
    newOwner,
    label,
    namespace
  }) {
    return {
      to: this._ensRegistryAddress,
      data: this._ensRegistry.interface.encodeFunctionData('setSubnodeOwner', [namehash$1(namespace), labelhash(label), newOwner])
    };
  }

  changeDomainOwnerTx({
    newOwner,
    namespace
  }) {
    return {
      to: this._ensRegistryAddress,
      data: this._ensRegistry.interface.encodeFunctionData('setOwner', [namehash$1(namespace), newOwner])
    };
  }

  deleteSubdomainTx({
    namespace
  }) {
    const namespaceArray = namespace.split('.');
    const node = namespaceArray.slice(1).join('.');
    const label = namespaceArray[0];
    return {
      to: this._ensRegistryAddress,
      data: this._ensRegistry.interface.encodeFunctionData('setSubnodeRecord', [namehash$1(node), labelhash(label), emptyAddress, emptyAddress, this._ttl])
    };
  }

  deleteDomain({
    namespace
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this._signerService.send(this.deleteDomainTx({
        namespace
      }));
    });
  }

  deleteDomainTx({
    namespace
  }) {
    return {
      to: this._ensRegistryAddress,
      data: this._ensRegistry.interface.encodeFunctionData('setRecord', [namehash$1(namespace), emptyAddress, emptyAddress, this._ttl])
    };
  }

  deleteSubdomain({
    namespace
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this._signerService.send(this.deleteSubdomainTx({
        namespace
      }));
    });
  }

  nonOwnedNodesOf({
    namespace,
    type,
    owner
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      if (![NamespaceType.Role, NamespaceType.Application, NamespaceType.Organization].includes(type)) {
        throw new Error(ERROR_MESSAGES.ENS_TYPE_NOT_SUPPORTED);
      }

      const namespacesToCheck = type === NamespaceType.Role ? [namespace] : type === NamespaceType.Application ? [namespace, NamespaceType.Application] : [namespace, NamespaceType.Application, NamespaceType.Organization];
      return Promise.all(namespacesToCheck.map(ns => this.getOwner({
        namespace: ns
      }))).then(owners => owners.filter(o => ![owner, emptyAddress].includes(o)));
    });
  }

  namespacesWithRelations(namespaces) {
    return __awaiter(this, void 0, void 0, function* () {
      return Promise.all(namespaces.map(namespace => __awaiter(this, void 0, void 0, function* () {
        const owner = yield this.getOwner({
          namespace
        });
        return {
          namespace,
          owner
        };
      })));
    });
  }

  static validateOwnerAddress(owner) {
    try {
      validateAddress(owner);
    } catch (_a) {
      throw new ENSOwnerNotValidAddressError(owner);
    }
  }

}

const _abi$2 = [{
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "previousAdmin",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "newAdmin",
    type: "address"
  }],
  name: "AdminChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "beacon",
    type: "address"
  }],
  name: "BeaconUpgraded",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "identity",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "at",
    type: "uint256"
  }],
  name: "IdentityCreated",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "identity",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "oferedto",
    type: "address"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "at",
    type: "uint256"
  }],
  name: "IdentityOfferCanceled",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "identity",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "offeredTo",
    type: "address"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "at",
    type: "uint256"
  }],
  name: "IdentityOfferRejected",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "identity",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "offeredTo",
    type: "address"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "at",
    type: "uint256"
  }],
  name: "IdentityOffered",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "identity",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "at",
    type: "uint256"
  }],
  name: "IdentityTransferred",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "previousOwner",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "newOwner",
    type: "address"
  }],
  name: "OwnershipTransferred",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "implementation",
    type: "address"
  }],
  name: "Upgraded",
  type: "event"
}, {
  inputs: [],
  name: "owner",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "renounceOwnership",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newOwner",
    type: "address"
  }],
  name: "transferOwnership",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newImplementation",
    type: "address"
  }],
  name: "upgradeTo",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newImplementation",
    type: "address"
  }, {
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }],
  name: "upgradeToAndCall",
  outputs: [],
  stateMutability: "payable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_libraryAddress",
    type: "address"
  }],
  name: "initialize",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "identity",
    type: "address"
  }],
  name: "verified",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "identity",
    type: "address"
  }],
  name: "compliant",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "identity",
    type: "address"
  }],
  name: "identityOwner",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_owner",
    type: "address"
  }],
  name: "createIdentity",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_owner",
    type: "address"
  }],
  name: "identityCreated",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_offeredTo",
    type: "address"
  }],
  name: "identityOffered",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_owner",
    type: "address"
  }],
  name: "identityAccepted",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_offeredTo",
    type: "address"
  }],
  name: "identityRejected",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_offeredTo",
    type: "address"
  }],
  name: "identityOfferCanceled",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "version",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "pure",
  type: "function"
}];
const _bytecode$2 = "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";
class IdentityManager__factory extends ContractFactory {
  constructor(...args) {
    if (args.length === 1) {
      super(_abi$2, _bytecode$2, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(overrides) {
    return super.deploy(overrides || {});
  }

  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }

  attach(address) {
    return super.attach(address);
  }

  connect(signer) {
    return super.connect(signer);
  }

  static createInterface() {
    return new utils.Interface(_abi$2);
  }

  static connect(address, signerOrProvider) {
    return new Contract(address, _abi$2, signerOrProvider);
  }

}
IdentityManager__factory.bytecode = _bytecode$2;
IdentityManager__factory.abi = _abi$2;

const _abi$1 = [{
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "value",
    type: "uint256"
  }],
  name: "TransactionSent",
  type: "event"
}, {
  inputs: [],
  name: "offeredTo",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "owner",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_owner",
    type: "address"
  }],
  name: "init",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_offeredTo",
    type: "address"
  }],
  name: "offer",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "acceptOffer",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "rejectOffer",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "cancelOffer",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }, {
    internalType: "uint256",
    name: "value",
    type: "uint256"
  }],
  name: "sendTransaction",
  outputs: [{
    internalType: "bool",
    name: "success",
    type: "bool"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes4",
    name: "interfaceId",
    type: "bytes4"
  }],
  name: "supportsInterface",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}];
const _bytecode$1 = "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";
class OfferableIdentity__factory extends ContractFactory {
  constructor(...args) {
    if (args.length === 1) {
      super(_abi$1, _bytecode$1, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(overrides) {
    return super.deploy(overrides || {});
  }

  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }

  attach(address) {
    return super.attach(address);
  }

  connect(signer) {
    return super.connect(signer);
  }

  static createInterface() {
    return new utils.Interface(_abi$1);
  }

  static connect(address, signerOrProvider) {
    return new Contract(address, _abi$1, signerOrProvider);
  }

}
OfferableIdentity__factory.bytecode = _bytecode$1;
OfferableIdentity__factory.abi = _abi$1;

class AssetsService {
  constructor(_signerService, _cacheClient) {
    this._signerService = _signerService;
    this._cacheClient = _cacheClient;
    this._assetInterface = OfferableIdentity__factory.createInterface();
    this._assetManagerInterface = IdentityManager__factory.createInterface();

    this._signerService.onInit(this.init.bind(this));
  }

  static create(signerService, cacheClient) {
    return __awaiter(this, void 0, void 0, function* () {
      const service = new AssetsService(signerService, cacheClient);
      yield service.init();
      return service;
    });
  }

  init() {
    return __awaiter(this, void 0, void 0, function* () {
      const chainId = this._signerService.chainId;
      this._owner = this._signerService.address;
      this._did = `did:${Methods.Erc1056}:${this._signerService.chainName()}:${this._owner}`;
      const chainConfig = chainConfigs()[chainId];
      this._assetManager = chainConfig.assetManagerAddress;
    });
  }

  registerAsset() {
    return __awaiter(this, void 0, void 0, function* () {
      const data = this._assetManagerInterface.encodeFunctionData('createIdentity', [this._owner]);

      const receipt = yield this._signerService.send({
        to: this._assetManager,
        data
      });
      const event = receipt.logs.map(l => this._assetManagerInterface.parseLog(l)).find(log => log.name === this._assetManagerInterface.events['IdentityCreated(address,address,uint256)'].name);
      const identity = event.args[0];
      let asset = yield this.getAssetById({
        id: `did:${Methods.Erc1056}:${this._signerService.chainName()}:${identity}`
      });
      let loops = 0;

      while (!asset && loops < 20) {
        asset = yield this.getAssetById({
          id: `did:${Methods.Erc1056}:${this._signerService.chainName()}:${identity}`
        });
        yield new Promise(resolve => setTimeout(resolve, 1000));
        loops++;
      }

      return identity;
    });
  }

  offerAsset({
    assetDID,
    offerTo
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      const assetContractAddress = addressOf(assetDID);
      const tx = this.offerAssetTx({
        assetContractAddress,
        offerTo: offerTo
      });
      yield this._signerService.send(tx);
    });
  }

  acceptAssetOffer({
    assetDID
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      const assetContractAddress = addressOf(assetDID);
      const tx = this.acceptOfferTx({
        assetContractAddress
      });
      yield this._signerService.send(tx);
    });
  }

  rejectAssetOffer({
    assetDID
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      const assetContractAddress = addressOf(assetDID);
      const tx = this.rejectOfferTx({
        assetContractAddress
      });
      yield this._signerService.send(tx);
    });
  }

  cancelAssetOffer({
    assetDID
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      const assetContractAddress = addressOf(assetDID);
      const tx = this.cancelOfferTx({
        assetContractAddress
      });
      yield this._signerService.send(tx);
    });
  }

  getOwnedAssets({
    did = this._did
  } = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      return this._cacheClient.getOwnedAssets(did);
    });
  }

  getOfferedAssets({
    did = this._did
  } = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      return this._cacheClient.getOfferedAssets(did);
    });
  }

  getAssetById({
    id
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      return this._cacheClient.getAssetById(id);
    });
  }

  getPreviouslyOwnedAssets({
    owner
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      return this._cacheClient.getPreviouslyOwnedAssets(owner);
    });
  }

  getAssetHistory(_a) {
    var {
      id
    } = _a,
        query = __rest(_a, ["id"]);

    return __awaiter(this, void 0, void 0, function* () {
      return this._cacheClient.getAssetHistory(id, Object.assign({}, query));
    });
  }

  offerAssetTx({
    offerTo,
    assetContractAddress
  }) {
    return {
      data: this._assetInterface.encodeFunctionData('offer', [offerTo]),
      to: assetContractAddress
    };
  }

  acceptOfferTx({
    assetContractAddress
  }) {
    return {
      data: this._assetInterface.encodeFunctionData('acceptOffer'),
      to: assetContractAddress
    };
  }

  rejectOfferTx({
    assetContractAddress
  }) {
    return {
      data: this._assetInterface.encodeFunctionData('rejectOffer'),
      to: assetContractAddress
    };
  }

  cancelOfferTx({
    assetContractAddress
  }) {
    return {
      data: this._assetInterface.encodeFunctionData('cancelOffer'),
      to: assetContractAddress
    };
  }

}

var AssetHistoryEventType;

(function (AssetHistoryEventType) {
  AssetHistoryEventType["ASSET_CREATED"] = "ASSET_CREATED";
  AssetHistoryEventType["ASSET_OFFERED"] = "ASSET_OFFERED";
  AssetHistoryEventType["ASSET_OFFER_CANCELED"] = "ASSET_OFFER_CANCELED";
  AssetHistoryEventType["ASSET_TRANSFERRED"] = "ASSET_TRANSFERRED";
  AssetHistoryEventType["ASSET_OFFER_REJECTED"] = "ASSET_OFFER_REJECTED";
})(AssetHistoryEventType || (AssetHistoryEventType = {}));

const _abi = [{
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "previousAdmin",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "newAdmin",
    type: "address"
  }],
  name: "AdminChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "beacon",
    type: "address"
  }],
  name: "BeaconUpgraded",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "previousOwner",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "newOwner",
    type: "address"
  }],
  name: "OwnershipTransferred",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "subject",
    type: "address"
  }, {
    indexed: false,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "version",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "expiry",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "address",
    name: "issuer",
    type: "address"
  }],
  name: "RoleRegistered",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "implementation",
    type: "address"
  }],
  name: "Upgraded",
  type: "event"
}, {
  inputs: [],
  name: "PROOF_TYPEHASH",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "owner",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  name: "proofHashes",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "renounceOwnership",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newOwner",
    type: "address"
  }],
  name: "transferOwnership",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newImplementation",
    type: "address"
  }],
  name: "upgradeTo",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newImplementation",
    type: "address"
  }, {
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }],
  name: "upgradeToAndCall",
  outputs: [],
  stateMutability: "payable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_didRegistry",
    type: "address"
  }, {
    internalType: "address",
    name: "_ensRegistry",
    type: "address"
  }],
  name: "initialize",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "subject",
    type: "address"
  }, {
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "uint256",
    name: "version",
    type: "uint256"
  }],
  name: "hasRole",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "subject",
    type: "address"
  }, {
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "uint256",
    name: "version",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "expiry",
    type: "uint256"
  }, {
    internalType: "address",
    name: "issuer",
    type: "address"
  }, {
    internalType: "bytes",
    name: "subject_agreement",
    type: "bytes"
  }, {
    internalType: "bytes",
    name: "role_proof",
    type: "bytes"
  }],
  name: "register",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "version",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "pure",
  type: "function"
}];
const _bytecode = "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";
class ClaimManager__factory extends ContractFactory {
  constructor(...args) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(overrides) {
    return super.deploy(overrides || {});
  }

  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }

  attach(address) {
    return super.attach(address);
  }

  connect(signer) {
    return super.connect(signer);
  }

  static createInterface() {
    return new utils.Interface(_abi);
  }

  static connect(address, signerOrProvider) {
    return new Contract(address, _abi, signerOrProvider);
  }

}
ClaimManager__factory.bytecode = _bytecode;
ClaimManager__factory.abi = _abi;

function canonizeSig(sig) {
  let suffix = sig.substr(130);

  if (suffix === '00') {
    suffix = '1b';
  } else if (suffix === '01') {
    suffix = '1c';
  }

  return sig.substr(0, 130) + suffix;
}

const validators = new Map();
function supportedDIDMethods() {
  return Array.from(validators.keys());
}
function isValidDID(did) {
  return Array.from(validators.values()).some(v => v(did));
}
function addSupportedDID(methodWithChain, validator) {
  validators.set(methodWithChain, validator);
}
addSupportedDID(`${Methods.Erc1056}:${Chain.EWC}`, isValidErc1056EWC);
addSupportedDID(`${Methods.Erc1056}:${Chain.VOLTA}`, isValidErc1056VOLTA);
const didPattern = '^(?:did:(?<method>[a-z0-9]+?):)((?<chain>[a-z0-9]+?):)?(?<id>0x[A-Fa-f0-9]{40})$';
function compareDID(didA, didB) {
  const matchA = didA.match(didPattern);

  if (!(matchA === null || matchA === void 0 ? void 0 : matchA.groups)) {
    throw new MalformedDIDError(didA);
  }

  const matchB = didB.match(didPattern);

  if (!(matchB === null || matchB === void 0 ? void 0 : matchB.groups)) {
    throw new MalformedDIDError(didB);
  }

  const {
    method: methodA,
    chain: chainA,
    id: idA
  } = matchA.groups;
  const {
    method: methodB,
    chain: chainB,
    id: idB
  } = matchB.groups;

  if (idA !== idB) {
    return false;
  }

  if (methodA !== methodB) {
    return false;
  }

  if (chainA && chainB && chainA !== chainB) {
    return false;
  }

  return true;
}

const {
  id,
  keccak256,
  defaultAbiCoder,
  solidityKeccak256,
  namehash,
  arrayify
} = utils;
class ClaimsService {
  constructor(_signerService, _domainsService, _cacheClient, _didRegistry) {
    this._signerService = _signerService;
    this._domainsService = _domainsService;
    this._cacheClient = _cacheClient;
    this._didRegistry = _didRegistry;
    this._claimManagerInterface = ClaimManager__factory.createInterface();

    this._signerService.onInit(this.init.bind(this));
  }

  static create(signerService, domainsService, cacheClient, didRegistry) {
    return __awaiter(this, void 0, void 0, function* () {
      const service = new ClaimsService(signerService, domainsService, cacheClient, didRegistry);
      yield service.init();
      return service;
    });
  }

  init() {
    return __awaiter(this, void 0, void 0, function* () {
      const chainId = this._signerService.chainId;
      this._claimManager = chainConfigs()[chainId].claimManagerAddress;
    });
  }

  hasOnChainRole(did, role, version) {
    return __awaiter(this, void 0, void 0, function* () {
      const data = this._claimManagerInterface.encodeFunctionData('hasRole', [addressOf(did), namehash(role), version]);

      const result = yield this._signerService.call({
        to: this._claimManager,
        data
      });
      const intFromHexString = Number.parseInt(result);
      return Boolean(intFromHexString);
    });
  }

  getClaimsBySubjects(subjects) {
    return __awaiter(this, void 0, void 0, function* () {
      return this._cacheClient.getClaimsBySubjects(subjects);
    });
  }

  getClaimsByRequester({
    did,
    isAccepted,
    namespace
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      return this._cacheClient.getClaimsByRequester(did, {
        isAccepted,
        namespace
      });
    });
  }

  getClaimsByIssuer({
    did,
    isAccepted,
    namespace
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      return this._cacheClient.getClaimsByIssuer(did, {
        isAccepted,
        namespace
      });
    });
  }

  getClaimsBySubject({
    did,
    isAccepted,
    namespace
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      return this._cacheClient.getClaimsBySubject(did, {
        isAccepted,
        namespace
      });
    });
  }

  getClaimById(claimId) {
    return __awaiter(this, void 0, void 0, function* () {
      return this._cacheClient.getClaimById(claimId);
    });
  }

  createClaimRequest({
    claim,
    subject = this._signerService.did,
    registrationTypes = [RegistrationTypes.OffChain]
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        claimType: role,
        claimTypeVersion: version
      } = claim;

      const {
        fields
      } = claim,
            strippedClaim = __rest(claim, ["fields"]);

      const data = Object.assign(Object.assign({}, strippedClaim), {
        requestorFields: claim.requestorFields || fields || []
      });
      const token = yield this._didRegistry.createPublicClaim({
        data,
        subject
      });
      yield this.verifyEnrolmentPrerequisites({
        subject,
        role
      });
      const issuer = [`did:${Methods.Erc1056}:${this._signerService.chainName()}:${emptyAddress}`];
      const message = {
        id: v4(),
        token,
        claimIssuer: issuer,
        requester: this._signerService.did,
        registrationTypes,
        claimType: role,
        claimTypeVersion: version.toString()
      };

      if (registrationTypes.includes(RegistrationTypes.OnChain)) {
        if (!version) {
          throw new Error(ERROR_MESSAGES.ONCHAIN_ROLE_VERSION_NOT_SPECIFIED);
        }

        message.subjectAgreement = yield this.approveRolePublishing({
          subject,
          role,
          version
        });
      }

      yield this._cacheClient.requestClaim(message);
    });
  }

  issueClaimRequest({
    requester,
    token,
    id,
    subjectAgreement,
    registrationTypes,
    issuerFields,
    publishOnChain = true
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        claimData,
        sub
      } = this._didRegistry.jwt.decode(token);

      yield this.verifyEnrolmentPrerequisites({
        subject: sub,
        role: claimData.claimType
      });
      const message = {
        id,
        requester,
        claimIssuer: [this._signerService.did],
        acceptedBy: this._signerService.did
      };
      const strippedClaimData = this.stripClaimData(claimData);

      if (registrationTypes.includes(RegistrationTypes.OnChain)) {
        const {
          claimType: role,
          claimTypeVersion: version
        } = claimData;
        const expiry = defaultClaimExpiry;
        const onChainProof = yield this.createOnChainProof(role, version, expiry, sub);
        message.onChainProof = onChainProof;

        if (publishOnChain) {
          yield this.registerOnchain({
            token,
            subjectAgreement,
            onChainProof,
            acceptedBy: this._signerService.did
          });
        }
      }

      if (registrationTypes.includes(RegistrationTypes.OffChain)) {
        const publicClaim = {
          did: sub,
          signer: this._signerService.did,
          claimData: Object.assign(Object.assign({}, strippedClaimData), issuerFields && {
            issuerFields
          })
        };
        message.issuedToken = yield this._didRegistry.issuePublicClaim({
          publicClaim
        });
      }

      yield this._cacheClient.issueClaim(this._signerService.did, message);
    });
  }

  extractClaimRequest(token) {
    const {
      claimData,
      sub
    } = this._didRegistry.jwt.decode(token);

    return Object.assign(Object.assign({}, claimData), {
      subject: sub
    });
  }

  registerOnchain(claim) {
    return __awaiter(this, void 0, void 0, function* () {
      if (claim.token) claim = Object.assign(Object.assign({}, claim), this.extractClaimRequest(claim.token));

      if (!claim.subjectAgreement && claim.subject === this._signerService.did && claim.claimType && claim.claimTypeVersion) {
        claim.subjectAgreement = yield this.approveRolePublishing({
          subject: this._signerService.did,
          role: claim.claimType,
          version: +claim.claimTypeVersion
        });
      }

      if (!readyToBeRegisteredOnchain(claim)) {
        throw new Error(ERROR_MESSAGES.CLAIM_WAS_NOT_ISSUED);
      }

      const {
        subject,
        claimTypeVersion,
        claimType,
        acceptedBy,
        subjectAgreement,
        onChainProof
      } = claim;
      const expiry = defaultClaimExpiry;

      const data = this._claimManagerInterface.encodeFunctionData('register', [addressOf(subject), namehash(claimType), claimTypeVersion, expiry, addressOf(acceptedBy), subjectAgreement, onChainProof]);

      yield this._signerService.send({
        to: this._claimManager,
        data
      });
    });
  }

  rejectClaimRequest({
    id,
    requesterDID,
    rejectionReason
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      const message = {
        id,
        requester: requesterDID,
        claimIssuer: [this._signerService.did],
        isRejected: true,
        rejectionReason
      };
      return this._cacheClient.rejectClaim(this._signerService.did, message);
    });
  }

  deleteClaim({
    id
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this._cacheClient.deleteClaim(id);
    });
  }

  issueClaim({
    subject,
    registrationTypes = [RegistrationTypes.OffChain],
    claim
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.verifyEnrolmentPrerequisites({
        subject,
        role: claim.claimType
      });
      const message = {
        id: v4(),
        requester: subject,
        claimIssuer: [this._signerService.did],
        acceptedBy: this._signerService.did
      };

      if (registrationTypes.includes(RegistrationTypes.OffChain)) {
        const publicClaim = {
          did: subject,
          signer: this._signerService.did,
          claimData: claim
        };
        message.issuedToken = yield this._didRegistry.issuePublicClaim({
          publicClaim
        });
      }

      if (registrationTypes.includes(RegistrationTypes.OnChain)) {
        const {
          claimType: role,
          claimTypeVersion: version
        } = claim;
        const expiry = defaultClaimExpiry;
        const onChainProof = yield this.createOnChainProof(role, version, expiry, subject);
        message.onChainProof = onChainProof;
        message.claimType = role;
        message.claimTypeVersion = version.toString();
      }

      yield this._cacheClient.issueClaim(this._signerService.did, message);
      return message.issuedToken;
    });
  }

  getClaimId({
    claimData
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        service = []
      } = yield this._didRegistry.getDidDocument();
      const {
        id,
        claimTypeVersion
      } = service.find(({
        profile,
        claimType,
        claimTypeVersion
      }) => Boolean(profile) || claimType === claimData.claimType && claimTypeVersion === claimData.claimTypeVersion) || {};

      if (claimData.profile && id) {
        return id;
      }

      if (claimData.claimType && id && claimData.claimTypeVersion === claimTypeVersion) {
        return id;
      }

      return v4();
    });
  }

  validatePublishPublicClaimRequest(registrationTypes, claim) {
    if (registrationTypes.includes(RegistrationTypes.OnChain) && !claim.claimType) {
      throw new Error(ERROR_MESSAGES.CLAIM_TYPE_REQUIRED_FOR_ON_CHAIN_REGISTRATION);
    }

    if (registrationTypes.includes(RegistrationTypes.OffChain) && !claim.token) {
      throw new Error(ERROR_MESSAGES.TOKEN_REQUIRED_FOR_OFF_CHAIN_REGISTRATION);
    }
  }

  publishPublicClaim({
    token,
    registrationTypes = [RegistrationTypes.OffChain],
    claim
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      claim.token = claim.token || token;
      this.validatePublishPublicClaimRequest(registrationTypes, claim);
      let url = undefined;

      if (registrationTypes.includes(RegistrationTypes.OnChain)) {
        const claims = yield this.getClaimsBySubject({
          did: this._signerService.did,
          namespace: claim.claimType,
          isAccepted: true
        });

        if (claims.length < 1) {
          throw new Error(ERROR_MESSAGES.PUBLISH_NOT_ISSUED_CLAIM);
        }

        const claimData = claims[0];
        yield this.registerOnchain(Object.assign(Object.assign({}, claimData), {
          onChainProof: claimData.onChainProof,
          acceptedBy: claimData.acceptedBy
        }));
      }

      if (registrationTypes.includes(RegistrationTypes.OffChain)) {
        const token = claim.token;
        const payload = yield this._didRegistry.decodeJWTToken({
          token
        });
        const {
          iss,
          claimData
        } = payload;
        let sub = payload.sub;

        if (!sub || sub.length === 0 || !isValidDID(sub)) {
          sub = this._signerService.did;
        }

        const verifiedDid = yield this._didRegistry.verifyPublicClaim(token, iss);

        if (!verifiedDid || !compareDID(verifiedDid, iss)) {
          throw new Error('Incorrect signature');
        }

        url = yield this._didRegistry.ipfsStore.save(token);
        const data = {
          type: DIDAttribute.ServicePoint,
          value: {
            id: yield this.getClaimId({
              claimData
            }),
            serviceEndpoint: url,
            hash: hashes.SHA256(token),
            hashAlg: 'SHA256'
          }
        };
        yield this._didRegistry.updateDocument({
          didAttribute: DIDAttribute.ServicePoint,
          data,
          did: sub
        });
      }

      return url;
    });
  }

  createSelfSignedClaim({
    data,
    subject
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      const token = yield this._didRegistry.createPublicClaim({
        data,
        subject
      });
      return yield this.publishPublicClaim({
        claim: {
          token
        }
      });
    });
  }

  getUserClaims({
    did = this._signerService.did
  } = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        service
      } = (yield this._didRegistry.getDidDocument({
        did
      })) || {};
      return service;
    });
  }

  verifyEnrolmentPrerequisites({
    subject,
    role
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      const roleDefinition = yield this._domainsService.getDefinition({
        type: NamespaceType.Role,
        namespace: role
      });

      if (!roleDefinition) {
        throw new Error(ERROR_MESSAGES.ROLE_NOT_EXISTS);
      }

      const {
        enrolmentPreconditions
      } = roleDefinition;
      if (!enrolmentPreconditions || enrolmentPreconditions.length === 0) return;
      const enroledRoles = new Set((yield this.getClaimsBySubject({
        did: subject,
        isAccepted: true
      })).map(({
        claimType
      }) => claimType));
      const requiredRoles = new Set(enrolmentPreconditions.filter(({
        type
      }) => type === PreconditionType.Role).map(({
        conditions
      }) => conditions).reduce((all, cur) => all.concat(cur), []));

      if (Array.from(requiredRoles).some(role => !enroledRoles.has(role))) {
        throw new Error(ERROR_MESSAGES.ROLE_PREREQUISITES_NOT_MET);
      }
    });
  }

  createOnChainProof(role, version, expiry, subject) {
    return __awaiter(this, void 0, void 0, function* () {
      const messageId = Buffer.from(typedMsgPrefix, 'hex');
      const chainId = this._signerService.chainId;
      const domainSeparator = utils.keccak256(defaultAbiCoder.encode(['bytes32', 'bytes32', 'bytes32', 'uint256', 'address'], [erc712_type_hash, utils.id('Claim Manager'), utils.id('1.0'), chainId, this._claimManager]));
      const proofHash = solidityKeccak256(['bytes', 'bytes32', 'bytes32'], [messageId, domainSeparator, utils.keccak256(defaultAbiCoder.encode(['bytes32', 'address', 'bytes32', 'uint', 'uint', 'address'], [proof_type_hash, addressOf(subject), namehash(role), version, expiry, this._signerService.address]))]);
      return canonizeSig(yield this._signerService.signMessage(arrayify(proofHash)));
    });
  }

  approveRolePublishing({
    subject,
    role,
    version
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      const erc712_type_hash = id('EIP712Domain(string name,string version,uint256 chainId,address verifyingContract)');
      const agreement_type_hash = id('Agreement(address subject,bytes32 role,uint256 version)');
      const chainId = this._signerService.chainId;
      const domainSeparator = keccak256(defaultAbiCoder.encode(['bytes32', 'bytes32', 'bytes32', 'uint256', 'address'], [erc712_type_hash, id('Claim Manager'), id('1.0'), chainId, this._claimManager]));
      const messageId = Buffer.from(typedMsgPrefix, 'hex');
      const agreementHash = solidityKeccak256(['bytes', 'bytes32', 'bytes32'], [messageId, domainSeparator, keccak256(defaultAbiCoder.encode(['bytes32', 'address', 'bytes32', 'uint256'], [agreement_type_hash, addressOf(subject), namehash(role), version]))]);
      return canonizeSig(yield this._signerService.signMessage(arrayify(agreementHash)));
    });
  }

  createIdentityProof() {
    return __awaiter(this, void 0, void 0, function* () {
      const blockNumber = yield this._signerService.provider.getBlockNumber();
      return this._didRegistry.createPublicClaim({
        data: {
          blockNumber
        }
      });
    });
  }

  createDelegateProof(delegateKey, identity, algorithm = Algorithms.EIP191) {
    return __awaiter(this, void 0, void 0, function* () {
      const provider = this._signerService.provider;
      const blockNumber = (yield provider.getBlockNumber()).toString();
      const payload = {
        iss: identity,
        claimData: {
          blockNumber
        }
      };

      if (algorithm === Algorithms.EIP191) {
        return new JWT(new Wallet(delegateKey)).sign(payload, {
          issuer: identity
        });
      } else if (algorithm === Algorithms.ES256) {
        return jsonwebtoken.sign(payload, privToPem(delegateKey, KeyType.Secp256r1), {
          issuer: identity
        });
      } else {
        throw new Error(ERROR_MESSAGES.JWT_ALGORITHM_NOT_SUPPORTED);
      }
    });
  }

  stripClaimData(data) {
    const claimData = __rest(data, ["fields"]);

    return claimData;
  }

}

function initWithPrivateKeySigner(privateKey, rpcUrl) {
  return __awaiter(this, void 0, void 0, function* () {
    const signerService = yield fromPrivateKey(privateKey, rpcUrl);
    return init(signerService);
  });
}
function initWithKms({
  bridge = defaultBridgeUrl,
  kmsServerUrl = defaultKmsServerUrl
} = {}) {
  return __awaiter(this, void 0, void 0, function* () {
    return init(yield fromKms(bridge, kmsServerUrl));
  });
}
function initWithMetamask() {
  return __awaiter(this, void 0, void 0, function* () {
    return init(yield fromMetaMask());
  });
}
function initWithWalletConnect(bridge = defaultBridgeUrl) {
  return __awaiter(this, void 0, void 0, function* () {
    return init(yield fromWalletConnectMetamask(bridge));
  });
}
function initWithGnosis(safeAppSdk) {
  return __awaiter(this, void 0, void 0, function* () {
    return init(yield fromGnosis(safeAppSdk));
  });
}
function initWithEKC(proxyUrl = defaultAzureProxyUrl) {
  return __awaiter(this, void 0, void 0, function* () {
    const signerService = new SignerService(yield EkcSigner.create(proxyUrl), ProviderType.EKC);
    yield signerService.init();
    return init(signerService);
  });
}
function init(signerService) {
  return __awaiter(this, void 0, void 0, function* () {
    const messagingService = yield MessagingService.create(signerService);

    function connectToCacheServer() {
      return __awaiter(this, void 0, void 0, function* () {
        const chainId = signerService.chainId;
        const stakingPoolFactoryAddress = chainConfigs()[chainId].stakingPoolFactoryAddress;
        const cacheClient = new CacheClient(signerService);
        yield cacheClient.init();
        yield cacheClient.login();
        const domainsService = yield DomainsService.create(signerService, cacheClient);
        const stakingAddressProvided = stakingPoolFactoryAddress && stakingPoolFactoryAddress.length;
        const stakingService = stakingAddressProvided ? yield StakingService.create(signerService, domainsService) : null;
        const stakingPoolService = stakingAddressProvided ? yield StakingFactoryService.create(signerService, domainsService) : null;
        const assetsService = yield AssetsService.create(signerService, cacheClient);

        function connectToDidRegistry(ipfsStore) {
          return __awaiter(this, void 0, void 0, function* () {
            const didRegistry = yield DidRegistry.connect(signerService, cacheClient, assetsService, ipfsStore);
            const claimsService = yield ClaimsService.create(signerService, domainsService, cacheClient, didRegistry);
            return {
              didRegistry,
              claimsService
            };
          });
        }

        return {
          cacheClient,
          domainsService,
          stakingService,
          assetsService,
          connectToDidRegistry,
          stakingPoolService
        };
      });
    }

    return {
      signerService,
      messagingService,
      connectToCacheServer
    };
  });
}

export { AssetHistoryEventType, AssetsService, CacheClient, ChangeOwnershipNotPossibleError, ClaimEventType, ClaimsService, DeletingNamespaceNotPossibleError, DidRegistry, DomainsService, ENSOwnerNotValidAddressError, ENSTypeNotSupportedError, ERROR_MESSAGES, EkcSigner, ExecutionEnvironment, IS_ETH_SIGNER, MalformedDIDError, MessagingMethod, MessagingService, MethodNotAvailableInNodeEnvError, NODE_FIELDS_KEY, NamespaceType, Order, PUBLIC_KEY, ProviderEvent, ProviderType, RegistrationTypes, SearchType, SignerService, StakeStatus, StakingFactoryService, StakingPool, StakingPoolService, StakingService, TEST_LOGIN_ENDPOINT, VOLTA_CHAIN_ID, addSupportedDID, agreement_type_hash, cacheConfigs, chainConfigs, compareDID, createWalletConnectProvider, defaultAzureProxyUrl, defaultBridgeUrl, defaultClaimExpiry, defaultKmsServerUrl, didPattern, emptyAddress, erc712_type_hash, executionEnvironment, fromGnosis, fromKms, fromMetaMask, fromPrivateKey, fromWalletConnectMetamask, getMessagingConfig, init, initWithEKC, initWithGnosis, initWithKms, initWithMetamask, initWithPrivateKeySigner, initWithWalletConnect, isMetamaskExtensionPresent, isValidDID, proof_type_hash, readyToBeRegisteredOnchain, setCacheConfig, setChainConfig, setMessagingConfig, supportedDIDMethods, typedMsgPrefix };
